import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client/react';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar.This scalar is serialized to a string in ISO 8601 format and parsed from a string in ISO 8601 format. */
  DateTimeISO: { input: any; output: any; }
};

export type Address = {
  __typename?: 'Address';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type Alarm = {
  __typename?: 'Alarm';
  /** Alert groups this alarm belongs to. A grouped alarm notifies through its group. */
  alertGroups?: Maybe<Array<AlarmAlertGroup>>;
  /** Cooldown period after alarm triggers. Format: HH:MM:SS (e.g., 00:05:00 for 5 minutes) */
  cooldownPeriod: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  /** Period between evaluations. Format: HH:MM:SS (e.g., 00:05:00 for 5 minutes) */
  evalPeriod: Scalars['String']['output'];
  /** Time window for evaluation. Format: HH:MM:SS (e.g., 00:05:00 for 5 minutes) */
  evalWindowSize: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isEnabled: Scalars['Boolean']['output'];
  isTriggered: Scalars['Boolean']['output'];
  /** The UTC date and time of when the alarm was last resolved. Null if never resolved before. */
  lastResolvedAt?: Maybe<Scalars['String']['output']>;
  /** The UTC date and time of when the alarm was last triggered. Null if never triggered before. */
  lastTriggeredAt?: Maybe<Scalars['String']['output']>;
  machines?: Maybe<Array<AlarmMachine>>;
  name: Scalars['String']['output'];
  /** IDs of notification channels to notify when alarm triggers */
  notificationChannelIds?: Maybe<Array<Scalars['String']['output']>>;
  signal: Scalars['String']['output'];
  signalCategory: Scalars['String']['output'];
  thresholdHigh: Scalars['Float']['output'];
  thresholdLow: Scalars['Float']['output'];
  thresholdMode: ThresholdMode;
  triggerMode: TriggerMode;
  /** Value for trigger evaluation. Percentage: [0-100], Period: seconds > 0, Spikes: count > 0 */
  triggerValue: Scalars['Float']['output'];
  unit?: Maybe<Scalars['String']['output']>;
  userId: Scalars['ID']['output'];
};

export type AlarmAlertGroup = {
  __typename?: 'AlarmAlertGroup';
  id: Scalars['ID']['output'];
  isTriggered: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type AlarmHistory = {
  __typename?: 'AlarmHistory';
  /** List of alarm history events */
  items: Array<AlarmHistoryItem>;
  /** Summary statistics for the period */
  summary?: Maybe<AlarmHistorySummary>;
};

export type AlarmHistoryItem = {
  __typename?: 'AlarmHistoryItem';
  /** State of the alarm */
  alarmTriggerState: AlarmTriggerState;
  /** Number of failed deliveries */
  failedDeliveries: Scalars['Float']['output'];
  /** Delivery details for each channel */
  notificationDeliveries?: Maybe<Array<NotificationDelivery>>;
  /** Subject of the notification */
  subject?: Maybe<Scalars['String']['output']>;
  /** Number of successful deliveries */
  successfulDeliveries: Scalars['Float']['output'];
  /** Timestamp of the event in UTC */
  timeUtc: Scalars['String']['output'];
  /** Values that triggered the alarm */
  triggerValues?: Maybe<Array<TriggerValue>>;
};

export type AlarmHistorySummary = {
  __typename?: 'AlarmHistorySummary';
  /** Total failed notifications */
  countNotificationsFail: Scalars['Float']['output'];
  /** Total successful notifications */
  countNotificationsSuccess: Scalars['Float']['output'];
  /** Total times alarm was resolved */
  countResolved: Scalars['Float']['output'];
  /** Total times alarm was triggered */
  countTriggered: Scalars['Float']['output'];
  /** Start time of the period */
  from: Scalars['String']['output'];
  /** End time of the period */
  to: Scalars['String']['output'];
};

export type AlarmMachine = {
  __typename?: 'AlarmMachine';
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  machineId?: Maybe<Scalars['String']['output']>;
};

/** State of an alarm trigger event */
export enum AlarmTriggerState {
  Resolved = 'Resolved',
  Triggered = 'Triggered'
}

export type AlarmsFilterInput = {
  /** When true, returns alarms for all users. Defaults to false (only current user's alarms). */
  allUsers?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by machine IDs */
  machineIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Search by alarm name */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Filter by signal names */
  signals?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AlarmsOrderByInput = {
  /** Sort by alarm name */
  name?: InputMaybe<SortOrder>;
  /** Sort by signal */
  signal?: InputMaybe<SortOrder>;
};

export type AlertGroup = {
  __typename?: 'AlertGroup';
  /** Member alarms of this group */
  alarms?: Maybe<Array<AlertGroupAlarm>>;
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** True if any member alarm is currently triggered */
  isAnyAlarmTriggered: Scalars['Boolean']['output'];
  /** True while the group counts as in trouble. Drives the group badge. */
  isTriggered: Scalars['Boolean']['output'];
  /** The UTC date and time of when the group was last evaluated. Null if never evaluated before. */
  lastEvaluatedAt?: Maybe<Scalars['String']['output']>;
  /** The UTC date and time of when the group last sent a resolved notification. Null if never resolved before. */
  lastResolvedAt?: Maybe<Scalars['String']['output']>;
  /** The UTC date and time of when the group last sent a triggered notification. Null if never triggered before. */
  lastTriggeredAt?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** IDs of notification channels that receive this group's messages */
  notificationChannelIds?: Maybe<Array<Scalars['String']['output']>>;
  /** Failed notification deliveries */
  notificationFailureCount: Scalars['Int']['output'];
  /** Successful notification deliveries */
  notificationSuccessCount: Scalars['Int']['output'];
  /** How many times the group has gone from clear to triggered */
  triggerCount: Scalars['Int']['output'];
  userId: Scalars['ID']['output'];
};

export type AlertGroupAlarm = {
  __typename?: 'AlertGroupAlarm';
  id: Scalars['ID']['output'];
  isTriggered: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type AlertGroupsFilterInput = {
  /** When true, returns alert groups for all users. Defaults to false (only current user's groups). */
  allUsers?: InputMaybe<Scalars['Boolean']['input']>;
  /** Return only groups that are currently triggered */
  isTriggered?: InputMaybe<Scalars['Boolean']['input']>;
  /** Search by group name. EDMS has no search parameter, so this is applied after the fetch. */
  search?: InputMaybe<Scalars['String']['input']>;
};

export type AlertGroupsOrderByInput = {
  /** Sort by creation date */
  createdAt?: InputMaybe<SortOrder>;
  /** Sort by when the group last triggered */
  lastTriggeredAt?: InputMaybe<SortOrder>;
  /** Sort by group name */
  name?: InputMaybe<SortOrder>;
  /** Sort by how many times the group has triggered */
  triggerCount?: InputMaybe<SortOrder>;
};

/** Type of notification channel (Email, Teams, or Grouped) */
export enum ChannelType {
  Email = 'Email',
  Grouped = 'Grouped',
  Teams = 'Teams'
}

export type CreateAlarmInput = {
  /** Cooldown period after alarm triggers. Format: HH:MM:SS (e.g., 00:05:00 for 5 minutes) */
  cooldownPeriod?: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  /** Period between evaluations. Format: HH:MM:SS (e.g., 00:05:00 for 5 minutes) */
  evalPeriod?: Scalars['String']['input'];
  /** Time window for evaluation. Format: HH:MM:SS (e.g., 00:05:00 for 5 minutes) */
  evalWindowSize?: Scalars['String']['input'];
  machineIds?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: Scalars['String']['input'];
  /** IDs of notification channels to notify when alarm triggers */
  notificationChannelIds?: InputMaybe<Array<Scalars['String']['input']>>;
  signal?: Scalars['String']['input'];
  signalCategory?: Scalars['String']['input'];
  /** High threshold value. Should be set if ThresholdMode is AboveHigh or OutsideRange */
  thresholdHigh?: Scalars['Float']['input'];
  /** Low threshold value. Should be set if ThresholdMode is BelowLow or OutsideRange */
  thresholdLow?: Scalars['Float']['input'];
  thresholdMode?: ThresholdMode;
  triggerMode?: TriggerMode;
  /** Value for trigger evaluation. Percentage: [0-100], Period: seconds > 0, Spikes: count > 0 */
  triggerValue?: Scalars['Float']['input'];
};

export type CreateAlertGroupInput = {
  /** IDs of the alarms that belong to this group */
  alarmIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Display name for the group. Max 200 characters. */
  name?: Scalars['String']['input'];
  /** IDs of notification channels that receive this group's messages */
  notificationChannelIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateNotificationChannelInput = {
  /** Type of notification channel */
  channelType: ChannelType;
  /** Channel description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Email recipients (comma-separated) for Email channels */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Channel IDs to group for Grouped channels */
  groupedChannelIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Whether the channel is active */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Channel name */
  name: Scalars['String']['input'];
  /** Teams webhook URL for Teams channels */
  webhookUrl?: InputMaybe<Scalars['String']['input']>;
};

export type Customer = {
  __typename?: 'Customer';
  country?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  customerCategory?: Maybe<Scalars['String']['output']>;
  defaultLanguage?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  ifsId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  representative?: Maybe<Scalars['String']['output']>;
};

export type DataPoint = {
  __typename?: 'DataPoint';
  /** Average value in this time window */
  avg: Scalars['Float']['output'];
  /** Number of values in this window */
  count?: Maybe<Scalars['Float']['output']>;
  /** The dimension values this data point was grouped by */
  dimensions?: Maybe<Array<DataPointDimension>>;
  /** Maximum value in this time window */
  max: Scalars['Float']['output'];
  /** Minimum value in this time window */
  min: Scalars['Float']['output'];
  /** Sum of the values in this window */
  sum?: Maybe<Scalars['Float']['output']>;
  /** Timestamp in UTC */
  timeUtc: Scalars['String']['output'];
};

export type DataPointDimension = {
  __typename?: 'DataPointDimension';
  /** Dimension name, e.g. StreamName */
  name: Scalars['String']['output'];
  /** Dimension value, e.g. Accept */
  value: Scalars['String']['output'];
};

export type EdmsProvisionResult = {
  __typename?: 'EdmsProvisionResult';
  message?: Maybe<Scalars['String']['output']>;
  retryAfterMs?: Maybe<Scalars['Float']['output']>;
  status: EdmsProvisionStatus;
};

/** Status of EDMS user provisioning */
export enum EdmsProvisionStatus {
  already_exists = 'already_exists',
  cooldown = 'cooldown',
  created = 'created',
  failed = 'failed',
  in_progress = 'in_progress',
  role_not_found = 'role_not_found',
  skipped = 'skipped'
}

export type Health = {
  __typename?: 'Health';
  status: Scalars['String']['output'];
  timestamp: Scalars['DateTimeISO']['output'];
  version: Scalars['String']['output'];
};

export type Machine = {
  __typename?: 'Machine';
  address?: Maybe<Address>;
  /** Machine alarms (hardware-generated alerts from EDMS) associated with this machine and their trigger state */
  alerts?: Maybe<Array<MachineAlarm>>;
  availableSignals?: Maybe<MachineAvailableSignals>;
  customer?: Maybe<MachineCustomer>;
  displayName?: Maybe<Scalars['String']['output']>;
  edgeDevice?: Maybe<MachineEdgeDevice>;
  family?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  machineId: Scalars['String']['output'];
  partNumber?: Maybe<Scalars['String']['output']>;
  plant?: Maybe<MachinePlant>;
  serial?: Maybe<Scalars['String']['output']>;
  soid?: Maybe<Scalars['String']['output']>;
  state?: Maybe<MachineState>;
};

export type MachineAlarm = {
  __typename?: 'MachineAlarm';
  /** Display name of the alarm */
  alarmName?: Maybe<Scalars['String']['output']>;
  /** Id of the alarm */
  id?: Maybe<Scalars['ID']['output']>;
  /** True if the alarm is currently triggered on this machine */
  isTriggered?: Maybe<Scalars['Boolean']['output']>;
  /** UTC date and time when the alarm was last resolved on this machine */
  lastResolvedAt?: Maybe<Scalars['String']['output']>;
  /** UTC date and time when the alarm was last triggered on this machine */
  lastTriggeredAt?: Maybe<Scalars['String']['output']>;
};

export type MachineAvailableSignal = {
  __typename?: 'MachineAvailableSignal';
  /** The dimensions the signal can get grouped by, if any */
  dimensions?: Maybe<Array<Scalars['String']['output']>>;
  lastTimeUtc?: Maybe<Scalars['DateTimeISO']['output']>;
  signal: Scalars['String']['output'];
  unit?: Maybe<Scalars['String']['output']>;
};

export type MachineAvailableSignals = {
  __typename?: 'MachineAvailableSignals';
  lastTimeUtc?: Maybe<Scalars['DateTimeISO']['output']>;
  signals?: Maybe<Array<MachineAvailableSignalsByCategory>>;
};

export type MachineAvailableSignalsByCategory = {
  __typename?: 'MachineAvailableSignalsByCategory';
  category: Scalars['String']['output'];
  signals?: Maybe<Array<MachineAvailableSignal>>;
};

export type MachineCustomer = {
  __typename?: 'MachineCustomer';
  country?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  customerCategory?: Maybe<Scalars['String']['output']>;
  defaultLanguage?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  ifsId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  representative?: Maybe<Scalars['String']['output']>;
};

export type MachineData = {
  __typename?: 'MachineData';
  /** End time of data range in UTC */
  endUtc?: Maybe<Scalars['String']['output']>;
  /** Error message if any */
  errMsg?: Maybe<Scalars['String']['output']>;
  /** Time series data points */
  items: Array<DataPoint>;
  /** Machine ID */
  machineId?: Maybe<Scalars['ID']['output']>;
  /** Signal name */
  signal?: Maybe<Scalars['String']['output']>;
  /** Signal category */
  signalCategory?: Maybe<Scalars['String']['output']>;
  /** Start time of data range in UTC */
  startUtc?: Maybe<Scalars['String']['output']>;
  /** Total count of data points */
  totalCount?: Maybe<Scalars['Float']['output']>;
};

export type MachineEdgeDevice = {
  __typename?: 'MachineEdgeDevice';
  connectionStatus?: Maybe<Scalars['String']['output']>;
  deviceId?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type MachineMetricData = {
  __typename?: 'MachineMetricData';
  dataPoints?: Maybe<Array<MetricDataPoint>>;
  isSingleMachine: Scalars['Boolean']['output'];
  machineIds: Array<Scalars['String']['output']>;
  metricType: MetricType;
  rangeData?: Maybe<Array<MetricRangeDataPoint>>;
  threshold?: Maybe<Scalars['Float']['output']>;
  timespan: MetricTimespan;
  unit: Scalars['String']['output'];
};

export type MachinePlant = {
  __typename?: 'MachinePlant';
  displayName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type MachineState = {
  __typename?: 'MachineState';
  isSynthetic?: Maybe<Scalars['Boolean']['output']>;
  lastRecordedState?: Maybe<Scalars['String']['output']>;
  lastRecordedStateTimeUtc?: Maybe<Scalars['DateTimeISO']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  timeUtc?: Maybe<Scalars['DateTimeISO']['output']>;
};

export type MachinesFilterInput = {
  /** Filter by address (partial match) */
  address1?: InputMaybe<Scalars['String']['input']>;
  /** Filter by cities (exact match on any of the provided city names) */
  cities?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by countries (exact match on any of the provided country names) */
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by plant country */
  country?: InputMaybe<Scalars['String']['input']>;
  /** Filter by country codes (exact match on any of the provided ISO country codes, e.g., 'US', 'DE', 'FR') */
  countryCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by customer ID (deprecated - use customerIds instead) */
  customerId?: InputMaybe<Scalars['String']['input']>;
  /** Filter by customer IDs (exact match on any of the provided IDs) */
  customerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by customer name (partial match) */
  customerName?: InputMaybe<Scalars['String']['input']>;
  /** Filter by machine display name (partial match) */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /** Filter by edge device IoT hub connectivity (any of: Online, Offline, Unknown, No device). Separate from machine status: a connected device can still report an offline machine */
  edgeDeviceConnectionStatuses?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by the IoT edge device id / ED-guid only (partial match). This is the id EDMS device management and MLOps use */
  edgeDeviceGuid?: InputMaybe<Scalars['String']['input']>;
  /** Filter by edge device ID. Matches either the EDMS database id or the IoT edge device id (ED-guid), so a value copied from either system works */
  edgeDeviceId?: InputMaybe<Scalars['String']['input']>;
  /** Filter by edge device name (partial match) */
  edgeDeviceName?: InputMaybe<Scalars['String']['input']>;
  /** Filter by edge device provisioning state (any of: provisioned, not_provisioned). A machine is provisioned once EDMS reports an IoT edge device id for it */
  edgeDeviceStatuses?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by machine family */
  family?: InputMaybe<Scalars['String']['input']>;
  /** Filter by machine families (exact match on any of the provided families) */
  familyIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter machines that have an edge device */
  hasEdgeDevice?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by machineId field (partial match) */
  machineIdFilter?: InputMaybe<Scalars['String']['input']>;
  /** Filter by machine IDs (exact match on any of the provided IDs) */
  machineIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by part number (partial match) */
  partNumber?: InputMaybe<Scalars['String']['input']>;
  /** Filter by plant ID (deprecated - use plantIds instead) */
  plantId?: InputMaybe<Scalars['String']['input']>;
  /** Filter by plant IDs (exact match on any of the provided IDs) */
  plantIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by plant name (partial match) */
  plantName?: InputMaybe<Scalars['String']['input']>;
  /** Filter by machine serial number (partial match) */
  serial?: InputMaybe<Scalars['String']['input']>;
  /** Filter by SOID (partial match) */
  soid?: InputMaybe<Scalars['String']['input']>;
  /** Filter by states/provinces (exact match on any of the provided state names) */
  states?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by machine statuses (exact match on any of the provided statuses: offline, ready, ready_with_warning, running, running_with_warning, not_ready, busy, unknown) */
  statuses?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by zip/postal code (partial match) */
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type MachinesOrderByInput = {
  /** Sort by address */
  address1?: InputMaybe<SortOrder>;
  /** Sort by city */
  city?: InputMaybe<SortOrder>;
  /** Sort by country name */
  country?: InputMaybe<SortOrder>;
  /** Sort by country code (e.g., 'US', 'DE') */
  countryCode?: InputMaybe<SortOrder>;
  /** Sort by customer ID */
  customerId?: InputMaybe<SortOrder>;
  /** Sort by customer name */
  customerName?: InputMaybe<SortOrder>;
  /** Sort by machine display name */
  displayName?: InputMaybe<SortOrder>;
  /** Sort by whether the edge device is connected to the IoT hub (Online, Offline, Unknown, then no device) */
  edgeDeviceConnectionStatus?: InputMaybe<SortOrder>;
  /** Sort by IoT edge device id (ED-guid) */
  edgeDeviceGuid?: InputMaybe<SortOrder>;
  /** Sort by edge device ID */
  edgeDeviceId?: InputMaybe<SortOrder>;
  /** Sort by edge device name */
  edgeDeviceName?: InputMaybe<SortOrder>;
  /** Sort by edge device provisioning state */
  edgeDeviceStatus?: InputMaybe<SortOrder>;
  /** Sort by family */
  family?: InputMaybe<SortOrder>;
  /** Sort by machine ID */
  id?: InputMaybe<SortOrder>;
  /** Sort by machine ID (machineId field) */
  machineId?: InputMaybe<SortOrder>;
  /** Sort by part number */
  partNumber?: InputMaybe<SortOrder>;
  /** Sort by plant ID */
  plantId?: InputMaybe<SortOrder>;
  /** Sort by plant name */
  plantName?: InputMaybe<SortOrder>;
  /** Sort by serial number */
  serial?: InputMaybe<SortOrder>;
  /** Sort by SOID */
  soid?: InputMaybe<SortOrder>;
  /** Sort by state/province */
  state?: InputMaybe<SortOrder>;
  /** Sort by machine status */
  status?: InputMaybe<SortOrder>;
  /** Sort by zip/postal code */
  zipCode?: InputMaybe<SortOrder>;
};

export type MetricDataPoint = {
  __typename?: 'MetricDataPoint';
  average: Scalars['Float']['output'];
  label?: Maybe<Scalars['String']['output']>;
  max: Scalars['Float']['output'];
  min: Scalars['Float']['output'];
  time: Scalars['Float']['output'];
};

export type MetricQueryInput = {
  machineIds?: Array<Scalars['String']['input']>;
  metricType?: MetricType;
  timespan?: MetricTimespan;
};

export type MetricRangeDataPoint = {
  __typename?: 'MetricRangeDataPoint';
  average: Scalars['Float']['output'];
  label?: Maybe<Scalars['String']['output']>;
  max: Scalars['Float']['output'];
  min: Scalars['Float']['output'];
  time: Scalars['Float']['output'];
};

/** Time ranges for metric data queries */
export enum MetricTimespan {
  ONE_YEAR = 'ONE_YEAR',
  SEVEN_DAYS = 'SEVEN_DAYS',
  SIX_MONTHS = 'SIX_MONTHS',
  TWENTY_FOUR_HOURS = 'TWENTY_FOUR_HOURS'
}

/** Types of metrics that can be queried for machines */
export enum MetricType {
  ENERGY_CONSUMPTION = 'ENERGY_CONSUMPTION',
  OUTPUT_RATE = 'OUTPUT_RATE',
  PRESSURE = 'PRESSURE',
  SPEED = 'SPEED',
  TEMPERATURE = 'TEMPERATURE',
  VIBRATION = 'VIBRATION'
}

export type Mutation = {
  __typename?: 'Mutation';
  /** Create a new alarm */
  createAlarm: Alarm;
  /** Create a new alert group over existing alarms */
  createAlertGroup: AlertGroup;
  /** Create a new notification channel */
  createNotificationChannel: NotificationChannel;
  /** Delete an alarm by ID (soft delete) */
  deleteAlarm: Scalars['Boolean']['output'];
  /** Delete an alert group by ID. The member alarms are left in place. */
  deleteAlertGroup: Scalars['Boolean']['output'];
  /** Delete a notification channel (soft delete) */
  deleteNotificationChannel: Scalars['Boolean']['output'];
  provisionCurrentUser: EdmsProvisionResult;
  /** Send a test notification to a notification channel */
  sendTestNotification: Scalars['Boolean']['output'];
  /** Send a test notification to every channel configured on an alert group */
  testAlertGroup: Scalars['Boolean']['output'];
  /** Update an existing alarm with partial data */
  updateAlarm?: Maybe<Alarm>;
  /** Update an existing alert group with partial data */
  updateAlertGroup?: Maybe<AlertGroup>;
  /** Update an existing notification channel */
  updateNotificationChannel: NotificationChannel;
};


export type MutationCreateAlarmArgs = {
  input: CreateAlarmInput;
};


export type MutationCreateAlertGroupArgs = {
  input: CreateAlertGroupInput;
};


export type MutationCreateNotificationChannelArgs = {
  input: CreateNotificationChannelInput;
};


export type MutationDeleteAlarmArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteAlertGroupArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteNotificationChannelArgs = {
  id: Scalars['String']['input'];
};


export type MutationSendTestNotificationArgs = {
  id: Scalars['String']['input'];
};


export type MutationTestAlertGroupArgs = {
  id: Scalars['String']['input'];
};


export type MutationUpdateAlarmArgs = {
  id: Scalars['String']['input'];
  input: UpdateAlarmInput;
};


export type MutationUpdateAlertGroupArgs = {
  id: Scalars['String']['input'];
  input: UpdateAlertGroupInput;
};


export type MutationUpdateNotificationChannelArgs = {
  id: Scalars['String']['input'];
  input: UpdateNotificationChannelInput;
};

export type NotificationChannel = {
  __typename?: 'NotificationChannel';
  channelType: ChannelType;
  description?: Maybe<Scalars['String']['output']>;
  /** Email address for Email channels */
  email?: Maybe<Scalars['String']['output']>;
  /** Channel IDs for Grouped channels */
  groupedChannelIds?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  isEnabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** Webhook URL for Teams channels */
  webhookUrl?: Maybe<Scalars['String']['output']>;
};

export type NotificationChannelTestResult = {
  __typename?: 'NotificationChannelTestResult';
  /** Notification channel ID */
  channelId: Scalars['String']['output'];
  /** ISO timestamp for when test was attempted */
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Result message shown in channel side panel */
  message: Scalars['String']['output'];
  /** Whether test delivery succeeded */
  success: Scalars['Boolean']['output'];
};

export type NotificationChannelsFilterInput = {
  /** Filter by channel type */
  channelType?: InputMaybe<ChannelType>;
  /** Filter by enabled status */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Search by name or description */
  search?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationChannelsOrderByInput = {
  /** Sort by channel type */
  channelType?: InputMaybe<SortOrder>;
  /** Sort by enabled status */
  isEnabled?: InputMaybe<SortOrder>;
  /** Sort by channel name */
  name?: InputMaybe<SortOrder>;
};

export type NotificationDelivery = {
  __typename?: 'NotificationDelivery';
  /** Error message if delivery failed */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The database id of the notification channel */
  notificationChannelId: Scalars['ID']['output'];
  /** The name of the notification channel */
  notificationChannelName?: Maybe<Scalars['String']['output']>;
  /** True if the notification was successfully delivered via this channel */
  success: Scalars['Boolean']['output'];
};

export type NotificationEvent = {
  __typename?: 'NotificationEvent';
  /** Database ID of the alarm associated with this notification */
  alarmId?: Maybe<Scalars['ID']['output']>;
  /** Name of the alarm associated with this notification */
  alarmName?: Maybe<Scalars['String']['output']>;
  /** State of the alarm when the notification was generated */
  alarmTriggerState: AlarmTriggerState;
  /** Database ID of the alert group the alarm belongs to */
  alertGroupId?: Maybe<Scalars['ID']['output']>;
  /** Failed deliveries across channels */
  failedDeliveries: Scalars['Float']['output'];
  /** Unique notification identifier */
  id: Scalars['ID']['output'];
  /** Database ID of the machine associated with this notification */
  machineId?: Maybe<Scalars['ID']['output']>;
  /** Display name of the machine associated with this notification */
  machineName?: Maybe<Scalars['String']['output']>;
  /** Alarms covered by this notification. Present when one send covers several alarms of an alert group */
  members?: Maybe<Array<NotificationMember>>;
  /** Delivery breakdown per notification channel */
  notificationDeliveries?: Maybe<Array<NotificationDelivery>>;
  /** Database ID of the notification event that produced this notification. One event covers every member of an alert group */
  notificationEventId?: Maybe<Scalars['ID']['output']>;
  /** Signal monitored by the alarm associated with this notification */
  signal?: Maybe<Scalars['String']['output']>;
  /** Category of the signal monitored by the alarm */
  signalCategory?: Maybe<Scalars['String']['output']>;
  /** Subject or message of the notification */
  subject?: Maybe<Scalars['String']['output']>;
  /** Successful deliveries across channels */
  successfulDeliveries: Scalars['Float']['output'];
  /** High threshold value of the alarm associated with this notification */
  thresholdHigh?: Maybe<Scalars['Float']['output']>;
  /** Low threshold value of the alarm associated with this notification */
  thresholdLow?: Maybe<Scalars['Float']['output']>;
  /** Threshold mode of the alarm associated with this notification */
  thresholdMode?: Maybe<ThresholdMode>;
  /** Timestamp of the notification in UTC */
  timeUtc: Scalars['String']['output'];
  /** Values that triggered the notification, when available */
  triggerValues?: Maybe<Array<TriggerValue>>;
  /** Unit of the signal monitored by the alarm, when available */
  unit?: Maybe<Scalars['String']['output']>;
};

export type NotificationFilterInput = {
  /** Optional list of alarm database IDs to filter on */
  alarmIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** When true, returns notifications for all users. Defaults to false (only current user's alarms). */
  allUsers?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional list of machine database IDs to filter on */
  machineIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type NotificationMember = {
  __typename?: 'NotificationMember';
  /** Database ID of the member alarm */
  alarmId?: Maybe<Scalars['ID']['output']>;
  /** Name of the member alarm */
  alarmName?: Maybe<Scalars['String']['output']>;
  /** Signal monitored by the member alarm */
  signal?: Maybe<Scalars['String']['output']>;
  /** Category of the signal monitored by the member alarm */
  signalCategory?: Maybe<Scalars['String']['output']>;
  /** High threshold value of the member alarm */
  thresholdHigh?: Maybe<Scalars['Float']['output']>;
  /** Low threshold value of the member alarm */
  thresholdLow?: Maybe<Scalars['Float']['output']>;
  /** Threshold mode of the member alarm */
  thresholdMode?: Maybe<ThresholdMode>;
  /** Values that triggered the member alarm, when available */
  triggerValues?: Maybe<Array<TriggerValue>>;
  /** Unit of the signal monitored by the member alarm */
  unit?: Maybe<Scalars['String']['output']>;
};

export type NotificationsOrderByInput = {
  /** Sort by alarm name */
  alarmName?: InputMaybe<SortOrder>;
  /** Sort by notification state (Triggered/Resolved) */
  alarmTriggerState?: InputMaybe<SortOrder>;
  /** Sort by failed delivery count */
  failedDeliveries?: InputMaybe<SortOrder>;
  /** Sort by machine name */
  machineName?: InputMaybe<SortOrder>;
  /** Sort by successful delivery count */
  successfulDeliveries?: InputMaybe<SortOrder>;
  /** Sort notifications by timestamp */
  timeUtc?: InputMaybe<SortOrder>;
};

export type NotificationsSummary = {
  __typename?: 'NotificationsSummary';
  /** Total failed notification deliveries across channels */
  countNotificationsFail?: Maybe<Scalars['Float']['output']>;
  /** Total successful notification deliveries across channels */
  countNotificationsSuccess?: Maybe<Scalars['Float']['output']>;
  /** Total resolved notifications */
  countResolved?: Maybe<Scalars['Float']['output']>;
  /** Total triggered notifications */
  countTriggered?: Maybe<Scalars['Float']['output']>;
  /** Start time window for the summary */
  from?: Maybe<Scalars['String']['output']>;
  /** End time window for the summary */
  to?: Maybe<Scalars['String']['output']>;
};

export type PaginatedAlarms = {
  __typename?: 'PaginatedAlarms';
  /** Total count of alarms matching the query */
  count: Scalars['Int']['output'];
  /** Array of alarms for the current page */
  rows: Array<Alarm>;
};

export type PaginatedAlertGroups = {
  __typename?: 'PaginatedAlertGroups';
  /** Total count of alert groups matching the query */
  count: Scalars['Int']['output'];
  /** Array of alert groups for the current page */
  rows: Array<AlertGroup>;
};

export type PaginatedMachines = {
  __typename?: 'PaginatedMachines';
  /** Total count of machines matching the query */
  count: Scalars['Int']['output'];
  /** Array of machines for the current page */
  rows: Array<Machine>;
};

export type PaginatedNotificationChannels = {
  __typename?: 'PaginatedNotificationChannels';
  /** Total count of channels matching the query */
  count: Scalars['Float']['output'];
  /** Array of channels for the current page */
  rows: Array<NotificationChannel>;
};

export type PaginatedNotifications = {
  __typename?: 'PaginatedNotifications';
  /** Total number of notifications matching the filter */
  count: Scalars['Float']['output'];
  /** Notifications for the current page */
  rows: Array<NotificationEvent>;
  /** Aggregated statistics for the filtered notifications */
  summary?: Maybe<NotificationsSummary>;
};

export type PaginationInput = {
  /** Maximum number of items to return (max: 1000) */
  limit?: Scalars['Int']['input'];
  /** Number of items to skip (offset) */
  offset?: Scalars['Int']['input'];
};

export type Plant = {
  __typename?: 'Plant';
  address?: Maybe<Address>;
  customerId?: Maybe<Scalars['ID']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  ifsId?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  /** Get a single alarm by ID */
  alarm?: Maybe<Alarm>;
  /** Get alarm trigger history for a specific alarm and machine combination */
  alarmHistory?: Maybe<AlarmHistory>;
  /** Get all alarms with pagination, filtering, and sorting */
  alarms: PaginatedAlarms;
  /** Get a single alert group by ID */
  alertGroup?: Maybe<AlertGroup>;
  /** Get all alert groups with pagination, filtering, and sorting. An alert group delivers one notification for several alarms. */
  alertGroups: PaginatedAlertGroups;
  authStatus: Scalars['String']['output'];
  currentUser?: Maybe<User>;
  customer?: Maybe<Customer>;
  customerByIfsId?: Maybe<Customer>;
  customers: Array<Customer>;
  getMachineMetricData: MachineMetricData;
  health: Health;
  machine?: Maybe<Machine>;
  /** Get time series data for a specific machine */
  machineData: MachineData;
  machines: PaginatedMachines;
  me?: Maybe<User>;
  /** Get a single notification channel by ID */
  notificationChannel?: Maybe<NotificationChannel>;
  /** Get persisted test notification results for a channel */
  notificationChannelTestResults: Array<NotificationChannelTestResult>;
  /** Get all notification channels with optional filtering */
  notificationChannels: PaginatedNotificationChannels;
  /** Get notifications with optional filtering, sorting, and pagination */
  notifications: PaginatedNotifications;
  plant?: Maybe<Plant>;
  plantByIfsId?: Maybe<Plant>;
  plants: Array<Plant>;
  user?: Maybe<User>;
  users: Array<User>;
};


export type QueryAlarmArgs = {
  id: Scalars['String']['input'];
};


export type QueryAlarmHistoryArgs = {
  alarmId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  machineId: Scalars['String']['input'];
};


export type QueryAlarmsArgs = {
  filter?: InputMaybe<AlarmsFilterInput>;
  orderBy?: InputMaybe<AlarmsOrderByInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryAlertGroupArgs = {
  id: Scalars['String']['input'];
};


export type QueryAlertGroupsArgs = {
  filter?: InputMaybe<AlertGroupsFilterInput>;
  orderBy?: InputMaybe<AlertGroupsOrderByInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryCustomerArgs = {
  id: Scalars['String']['input'];
};


export type QueryCustomerByIfsIdArgs = {
  ifsId: Scalars['String']['input'];
};


export type QueryCustomersArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetMachineMetricDataArgs = {
  input: MetricQueryInput;
};


export type QueryMachineArgs = {
  id: Scalars['String']['input'];
};


export type QueryMachineDataArgs = {
  dimensions?: InputMaybe<Array<Scalars['String']['input']>>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  numDataPoints?: InputMaybe<Scalars['Float']['input']>;
  overTime?: InputMaybe<Scalars['Boolean']['input']>;
  signal?: InputMaybe<Scalars['String']['input']>;
  signalCategory?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
  timeRange?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMachinesArgs = {
  filter?: InputMaybe<MachinesFilterInput>;
  orderBy?: InputMaybe<MachinesOrderByInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryNotificationChannelArgs = {
  id: Scalars['String']['input'];
};


export type QueryNotificationChannelTestResultsArgs = {
  id: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryNotificationChannelsArgs = {
  filter?: InputMaybe<NotificationChannelsFilterInput>;
  orderBy?: InputMaybe<NotificationChannelsOrderByInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryNotificationsArgs = {
  filter?: InputMaybe<NotificationFilterInput>;
  orderBy?: InputMaybe<NotificationsOrderByInput>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryPlantArgs = {
  id: Scalars['String']['input'];
};


export type QueryPlantByIfsIdArgs = {
  ifsId: Scalars['String']['input'];
};


export type QueryPlantsArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};

/** Sort order for query results (ascending or descending) */
export enum SortOrder {
  asc = 'asc',
  desc = 'desc'
}

export type TagEntry = {
  __typename?: 'TagEntry';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** Determines when an alarm triggers based on threshold values */
export enum ThresholdMode {
  AboveHigh = 'AboveHigh',
  BelowLow = 'BelowLow',
  OutsideRange = 'OutsideRange'
}

/** Evaluation method for alarm triggering (Percentage/Period/Spikes) */
export enum TriggerMode {
  Percentage = 'Percentage',
  Period = 'Period',
  Spikes = 'Spikes'
}

export type TriggerValue = {
  __typename?: 'TriggerValue';
  mode?: Maybe<TriggerMode>;
  /** Key-value pairs of tags */
  tags?: Maybe<Array<TagEntry>>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type UpdateAlarmInput = {
  /** Cooldown period after alarm triggers. Format: HH:MM:SS */
  cooldownPeriod?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Period between evaluations. Format: HH:MM:SS */
  evalPeriod?: InputMaybe<Scalars['String']['input']>;
  /** Time window for evaluation. Format: HH:MM:SS */
  evalWindowSize?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  machineIds?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** IDs of notification channels to notify when alarm triggers */
  notificationChannelIds?: InputMaybe<Array<Scalars['String']['input']>>;
  signal?: InputMaybe<Scalars['String']['input']>;
  signalCategory?: InputMaybe<Scalars['String']['input']>;
  thresholdHigh?: InputMaybe<Scalars['Float']['input']>;
  thresholdLow?: InputMaybe<Scalars['Float']['input']>;
  thresholdMode?: InputMaybe<ThresholdMode>;
  triggerMode?: InputMaybe<TriggerMode>;
  triggerValue?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateAlertGroupInput = {
  /** Replaces the group's member alarms when present */
  alarmIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Display name for the group. Max 200 characters. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Replaces the group's notification channels when present */
  notificationChannelIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateNotificationChannelInput = {
  /** Type of notification channel */
  channelType: ChannelType;
  /** Channel description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Email recipients (comma-separated) for Email channels */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Channel IDs to group for Grouped channels */
  groupedChannelIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Whether the channel is enabled */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Channel name */
  name: Scalars['String']['input'];
  /** Teams webhook URL for Teams channels */
  webhookUrl?: InputMaybe<Scalars['String']['input']>;
};

export type User = {
  __typename?: 'User';
  createdAt: Scalars['DateTimeISO']['output'];
  /** The user's id in EDMS. Alarms and alert groups carry this id as their owner (userId). Null when EDMS does not know the user. */
  edmsUserId?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type ProvisionCurrentUserMutationVariables = Exact<{ [key: string]: never; }>;


export type ProvisionCurrentUserMutation = { __typename?: 'Mutation', provisionCurrentUser: { __typename?: 'EdmsProvisionResult', status: EdmsProvisionStatus, message?: string | null, retryAfterMs?: number | null } };

export type AlarmMachineFieldsFragment = { __typename?: 'AlarmMachine', id: string, machineId?: string | null, displayName?: string | null };

export type AlarmFieldsFragment = { __typename?: 'Alarm', id: string, isEnabled: boolean, isTriggered: boolean, lastTriggeredAt?: string | null, lastResolvedAt?: string | null, createdAt: string, name: string, description?: string | null, signalCategory: string, signal: string, unit?: string | null, evalWindowSize: string, evalPeriod: string, cooldownPeriod: string, thresholdLow: number, thresholdHigh: number, thresholdMode: ThresholdMode, triggerMode: TriggerMode, triggerValue: number, userId: string, machines?: Array<{ __typename?: 'AlarmMachine', id: string, machineId?: string | null, displayName?: string | null }> | null, alertGroups?: Array<{ __typename?: 'AlarmAlertGroup', id: string, name: string, isTriggered: boolean }> | null };

export type GetAlarmsQueryVariables = Exact<{
  orderBy?: InputMaybe<AlarmsOrderByInput>;
  filter?: InputMaybe<AlarmsFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type GetAlarmsQuery = { __typename?: 'Query', alarms: { __typename?: 'PaginatedAlarms', count: number, rows: Array<{ __typename?: 'Alarm', id: string, isEnabled: boolean, isTriggered: boolean, lastTriggeredAt?: string | null, lastResolvedAt?: string | null, createdAt: string, name: string, description?: string | null, signalCategory: string, signal: string, unit?: string | null, evalWindowSize: string, evalPeriod: string, cooldownPeriod: string, thresholdLow: number, thresholdHigh: number, thresholdMode: ThresholdMode, triggerMode: TriggerMode, triggerValue: number, userId: string, machines?: Array<{ __typename?: 'AlarmMachine', id: string, machineId?: string | null, displayName?: string | null }> | null, alertGroups?: Array<{ __typename?: 'AlarmAlertGroup', id: string, name: string, isTriggered: boolean }> | null }> } };

export type GetAlarmQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetAlarmQuery = { __typename?: 'Query', alarm?: { __typename?: 'Alarm', id: string, isEnabled: boolean, isTriggered: boolean, lastTriggeredAt?: string | null, lastResolvedAt?: string | null, createdAt: string, name: string, description?: string | null, signalCategory: string, signal: string, unit?: string | null, evalWindowSize: string, evalPeriod: string, cooldownPeriod: string, thresholdLow: number, thresholdHigh: number, thresholdMode: ThresholdMode, triggerMode: TriggerMode, triggerValue: number, userId: string, machines?: Array<{ __typename?: 'AlarmMachine', id: string, machineId?: string | null, displayName?: string | null }> | null, alertGroups?: Array<{ __typename?: 'AlarmAlertGroup', id: string, name: string, isTriggered: boolean }> | null } | null };

export type CreateAlarmMutationVariables = Exact<{
  input: CreateAlarmInput;
}>;


export type CreateAlarmMutation = { __typename?: 'Mutation', createAlarm: { __typename?: 'Alarm', id: string, isEnabled: boolean, isTriggered: boolean, lastTriggeredAt?: string | null, lastResolvedAt?: string | null, createdAt: string, name: string, description?: string | null, signalCategory: string, signal: string, unit?: string | null, evalWindowSize: string, evalPeriod: string, cooldownPeriod: string, thresholdLow: number, thresholdHigh: number, thresholdMode: ThresholdMode, triggerMode: TriggerMode, triggerValue: number, userId: string, machines?: Array<{ __typename?: 'AlarmMachine', id: string, machineId?: string | null, displayName?: string | null }> | null, alertGroups?: Array<{ __typename?: 'AlarmAlertGroup', id: string, name: string, isTriggered: boolean }> | null } };

export type UpdateAlarmMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: UpdateAlarmInput;
}>;


export type UpdateAlarmMutation = { __typename?: 'Mutation', updateAlarm?: { __typename?: 'Alarm', id: string, isEnabled: boolean, isTriggered: boolean, lastTriggeredAt?: string | null, lastResolvedAt?: string | null, createdAt: string, name: string, description?: string | null, signalCategory: string, signal: string, unit?: string | null, evalWindowSize: string, evalPeriod: string, cooldownPeriod: string, thresholdLow: number, thresholdHigh: number, thresholdMode: ThresholdMode, triggerMode: TriggerMode, triggerValue: number, userId: string, machines?: Array<{ __typename?: 'AlarmMachine', id: string, machineId?: string | null, displayName?: string | null }> | null, alertGroups?: Array<{ __typename?: 'AlarmAlertGroup', id: string, name: string, isTriggered: boolean }> | null } | null };

export type SetAlarmEnabledMutationVariables = Exact<{
  id: Scalars['String']['input'];
  isEnabled: Scalars['Boolean']['input'];
}>;


export type SetAlarmEnabledMutation = { __typename?: 'Mutation', updateAlarm?: { __typename?: 'Alarm', id: string, isEnabled: boolean } | null };

export type DeleteAlarmMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteAlarmMutation = { __typename?: 'Mutation', deleteAlarm: boolean };

export type AlertGroupAlarmFieldsFragment = { __typename?: 'AlertGroupAlarm', id: string, name?: string | null, isTriggered: boolean };

export type AlertGroupFieldsFragment = { __typename?: 'AlertGroup', id: string, name: string, createdAt: string, userId: string, isTriggered: boolean, isAnyAlarmTriggered: boolean, lastTriggeredAt?: string | null, lastResolvedAt?: string | null, lastEvaluatedAt?: string | null, triggerCount: number, notificationSuccessCount: number, notificationFailureCount: number, notificationChannelIds?: Array<string> | null, alarms?: Array<{ __typename?: 'AlertGroupAlarm', id: string, name?: string | null, isTriggered: boolean }> | null };

export type GetAlertGroupsQueryVariables = Exact<{
  orderBy?: InputMaybe<AlertGroupsOrderByInput>;
  filter?: InputMaybe<AlertGroupsFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type GetAlertGroupsQuery = { __typename?: 'Query', alertGroups: { __typename?: 'PaginatedAlertGroups', count: number, rows: Array<{ __typename?: 'AlertGroup', id: string, name: string, createdAt: string, userId: string, isTriggered: boolean, isAnyAlarmTriggered: boolean, lastTriggeredAt?: string | null, lastResolvedAt?: string | null, lastEvaluatedAt?: string | null, triggerCount: number, notificationSuccessCount: number, notificationFailureCount: number, notificationChannelIds?: Array<string> | null, alarms?: Array<{ __typename?: 'AlertGroupAlarm', id: string, name?: string | null, isTriggered: boolean }> | null }> } };

export type GetAlertGroupQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetAlertGroupQuery = { __typename?: 'Query', alertGroup?: { __typename?: 'AlertGroup', id: string, name: string, createdAt: string, userId: string, isTriggered: boolean, isAnyAlarmTriggered: boolean, lastTriggeredAt?: string | null, lastResolvedAt?: string | null, lastEvaluatedAt?: string | null, triggerCount: number, notificationSuccessCount: number, notificationFailureCount: number, notificationChannelIds?: Array<string> | null, alarms?: Array<{ __typename?: 'AlertGroupAlarm', id: string, name?: string | null, isTriggered: boolean }> | null } | null };

export type CreateAlertGroupMutationVariables = Exact<{
  input: CreateAlertGroupInput;
}>;


export type CreateAlertGroupMutation = { __typename?: 'Mutation', createAlertGroup: { __typename?: 'AlertGroup', id: string, name: string, createdAt: string, userId: string, isTriggered: boolean, isAnyAlarmTriggered: boolean, lastTriggeredAt?: string | null, lastResolvedAt?: string | null, lastEvaluatedAt?: string | null, triggerCount: number, notificationSuccessCount: number, notificationFailureCount: number, notificationChannelIds?: Array<string> | null, alarms?: Array<{ __typename?: 'AlertGroupAlarm', id: string, name?: string | null, isTriggered: boolean }> | null } };

export type UpdateAlertGroupMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: UpdateAlertGroupInput;
}>;


export type UpdateAlertGroupMutation = { __typename?: 'Mutation', updateAlertGroup?: { __typename?: 'AlertGroup', id: string, name: string, createdAt: string, userId: string, isTriggered: boolean, isAnyAlarmTriggered: boolean, lastTriggeredAt?: string | null, lastResolvedAt?: string | null, lastEvaluatedAt?: string | null, triggerCount: number, notificationSuccessCount: number, notificationFailureCount: number, notificationChannelIds?: Array<string> | null, alarms?: Array<{ __typename?: 'AlertGroupAlarm', id: string, name?: string | null, isTriggered: boolean }> | null } | null };

export type DeleteAlertGroupMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteAlertGroupMutation = { __typename?: 'Mutation', deleteAlertGroup: boolean };

export type TestAlertGroupMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type TestAlertGroupMutation = { __typename?: 'Mutation', testAlertGroup: boolean };

export type GetCustomersQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetCustomersQuery = { __typename?: 'Query', customers: Array<{ __typename?: 'Customer', id: string, ifsId: string, name: string, displayName?: string | null, defaultLanguage?: string | null, country?: string | null, countryCode?: string | null, representative?: string | null, customerCategory?: string | null }> };

export type GetCustomerQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetCustomerQuery = { __typename?: 'Query', customer?: { __typename?: 'Customer', id: string, ifsId: string, name: string, displayName?: string | null, defaultLanguage?: string | null, country?: string | null, countryCode?: string | null, representative?: string | null, customerCategory?: string | null } | null };

export type GetCustomerByIfsIdQueryVariables = Exact<{
  ifsId: Scalars['String']['input'];
}>;


export type GetCustomerByIfsIdQuery = { __typename?: 'Query', customerByIfsId?: { __typename?: 'Customer', id: string, ifsId: string, name: string, displayName?: string | null, defaultLanguage?: string | null, country?: string | null, countryCode?: string | null, representative?: string | null, customerCategory?: string | null } | null };

export type GetMachinesAvailableSignalsQueryVariables = Exact<{
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetMachinesAvailableSignalsQuery = { __typename?: 'Query', machinesSignals: { __typename?: 'PaginatedMachines', rows: Array<{ __typename?: 'Machine', id: string, machineId: string, displayName?: string | null, availableSignals?: { __typename?: 'MachineAvailableSignals', lastTimeUtc?: any | null, signals?: Array<{ __typename?: 'MachineAvailableSignalsByCategory', category: string, signals?: Array<{ __typename?: 'MachineAvailableSignal', signal: string, unit?: string | null, lastTimeUtc?: any | null }> | null }> | null } | null }> } };

export type GetMachineMetricDataQueryVariables = Exact<{
  input: MetricQueryInput;
}>;


export type GetMachineMetricDataQuery = { __typename?: 'Query', getMachineMetricData: { __typename?: 'MachineMetricData', isSingleMachine: boolean, machineIds: Array<string>, metricType: MetricType, timespan: MetricTimespan, unit: string, threshold?: number | null, dataPoints?: Array<{ __typename?: 'MetricDataPoint', time: number, min: number, max: number, average: number, label?: string | null }> | null, rangeData?: Array<{ __typename?: 'MetricRangeDataPoint', time: number, min: number, max: number, average: number, label?: string | null }> | null } };

export type GetMachinesQueryVariables = Exact<{
  filter?: InputMaybe<MachinesFilterInput>;
  orderBy?: InputMaybe<MachinesOrderByInput>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type GetMachinesQuery = { __typename?: 'Query', machines: { __typename?: 'PaginatedMachines', count: number, rows: Array<{ __typename?: 'Machine', id: string, machineId: string, displayName?: string | null, serial?: string | null, partNumber?: string | null, soid?: string | null, family?: string | null, plant?: { __typename?: 'MachinePlant', id?: string | null, displayName?: string | null } | null, customer?: { __typename?: 'MachineCustomer', id?: string | null, ifsId?: string | null, name?: string | null, displayName?: string | null, defaultLanguage?: string | null, country?: string | null, countryCode?: string | null, representative?: string | null, customerCategory?: string | null } | null, edgeDevice?: { __typename?: 'MachineEdgeDevice', id?: string | null, deviceId?: string | null, displayName?: string | null, connectionStatus?: string | null } | null, address?: { __typename?: 'Address', id?: string | null, address1?: string | null, address2?: string | null, zipCode?: string | null, city?: string | null, country?: string | null, countryCode?: string | null, state?: string | null, county?: string | null, latitude?: number | null, longitude?: number | null } | null, state?: { __typename?: 'MachineState', timeUtc?: any | null, state?: string | null, isSynthetic?: boolean | null, lastRecordedState?: string | null, lastRecordedStateTimeUtc?: any | null } | null, alerts?: Array<{ __typename?: 'MachineAlarm', id?: string | null, alarmName?: string | null, isTriggered?: boolean | null, lastTriggeredAt?: string | null, lastResolvedAt?: string | null }> | null }> } };

export type GetMachineQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetMachineQuery = { __typename?: 'Query', machine?: { __typename?: 'Machine', id: string, machineId: string, displayName?: string | null, serial?: string | null, partNumber?: string | null, soid?: string | null, family?: string | null, plant?: { __typename?: 'MachinePlant', id?: string | null, displayName?: string | null } | null, customer?: { __typename?: 'MachineCustomer', id?: string | null, ifsId?: string | null, name?: string | null, displayName?: string | null, defaultLanguage?: string | null, country?: string | null, countryCode?: string | null, representative?: string | null, customerCategory?: string | null } | null, edgeDevice?: { __typename?: 'MachineEdgeDevice', id?: string | null, deviceId?: string | null, displayName?: string | null, connectionStatus?: string | null } | null, address?: { __typename?: 'Address', id?: string | null, address1?: string | null, address2?: string | null, zipCode?: string | null, city?: string | null, country?: string | null, countryCode?: string | null, state?: string | null, county?: string | null, latitude?: number | null, longitude?: number | null } | null, state?: { __typename?: 'MachineState', timeUtc?: any | null, state?: string | null, isSynthetic?: boolean | null, lastRecordedState?: string | null, lastRecordedStateTimeUtc?: any | null } | null, availableSignals?: { __typename?: 'MachineAvailableSignals', lastTimeUtc?: any | null, signals?: Array<{ __typename?: 'MachineAvailableSignalsByCategory', category: string, signals?: Array<{ __typename?: 'MachineAvailableSignal', signal: string, unit?: string | null, lastTimeUtc?: any | null, dimensions?: Array<string> | null }> | null }> | null } | null } | null };

export type MachineDataPointFieldsFragment = { __typename?: 'DataPoint', timeUtc: string, min: number, max: number, avg: number };

export type MachineDataFieldsFragment = { __typename?: 'MachineData', machineId?: string | null, startUtc?: string | null, endUtc?: string | null, signalCategory?: string | null, signal?: string | null, totalCount?: number | null, errMsg?: string | null, items: Array<{ __typename?: 'DataPoint', timeUtc: string, min: number, max: number, avg: number }> };

export type GetMachineDataQueryVariables = Exact<{
  id: Scalars['String']['input'];
  signalCategory?: InputMaybe<Scalars['String']['input']>;
  signal?: InputMaybe<Scalars['String']['input']>;
  timeRange?: InputMaybe<Scalars['String']['input']>;
  numDataPoints?: InputMaybe<Scalars['Float']['input']>;
}>;


export type GetMachineDataQuery = { __typename?: 'Query', machineData: { __typename?: 'MachineData', machineId?: string | null, startUtc?: string | null, endUtc?: string | null, signalCategory?: string | null, signal?: string | null, totalCount?: number | null, errMsg?: string | null, items: Array<{ __typename?: 'DataPoint', timeUtc: string, min: number, max: number, avg: number }> } };

export type GetMachineGroupedDataQueryVariables = Exact<{
  id: Scalars['String']['input'];
  signalCategory: Scalars['String']['input'];
  signal: Scalars['String']['input'];
  dimensions: Array<Scalars['String']['input']> | Scalars['String']['input'];
  overTime: Scalars['Boolean']['input'];
  numDataPoints?: InputMaybe<Scalars['Float']['input']>;
  startTime: Scalars['String']['input'];
  endTime: Scalars['String']['input'];
}>;


export type GetMachineGroupedDataQuery = { __typename?: 'Query', machineData: { __typename?: 'MachineData', machineId?: string | null, signalCategory?: string | null, signal?: string | null, errMsg?: string | null, items: Array<{ __typename?: 'DataPoint', timeUtc: string, sum?: number | null, count?: number | null, dimensions?: Array<{ __typename?: 'DataPointDimension', name: string, value: string }> | null }> } };

export type NotificationChannelFieldsFragment = { __typename?: 'NotificationChannel', id: string, name: string, description?: string | null, isEnabled: boolean, channelType: ChannelType, email?: string | null, webhookUrl?: string | null, groupedChannelIds?: Array<string> | null };

export type GetNotificationChannelsQueryVariables = Exact<{
  filter?: InputMaybe<NotificationChannelsFilterInput>;
  orderBy?: InputMaybe<NotificationChannelsOrderByInput>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type GetNotificationChannelsQuery = { __typename?: 'Query', notificationChannels: { __typename?: 'PaginatedNotificationChannels', count: number, rows: Array<{ __typename?: 'NotificationChannel', id: string, name: string, description?: string | null, isEnabled: boolean, channelType: ChannelType, email?: string | null, webhookUrl?: string | null, groupedChannelIds?: Array<string> | null }> } };

export type GetNotificationChannelQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetNotificationChannelQuery = { __typename?: 'Query', notificationChannel?: { __typename?: 'NotificationChannel', id: string, name: string, description?: string | null, isEnabled: boolean, channelType: ChannelType, email?: string | null, webhookUrl?: string | null, groupedChannelIds?: Array<string> | null } | null };

export type CreateNotificationChannelMutationVariables = Exact<{
  input: CreateNotificationChannelInput;
}>;


export type CreateNotificationChannelMutation = { __typename?: 'Mutation', createNotificationChannel: { __typename?: 'NotificationChannel', id: string, name: string, description?: string | null, isEnabled: boolean, channelType: ChannelType, email?: string | null, webhookUrl?: string | null, groupedChannelIds?: Array<string> | null } };

export type UpdateNotificationChannelMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: UpdateNotificationChannelInput;
}>;


export type UpdateNotificationChannelMutation = { __typename?: 'Mutation', updateNotificationChannel: { __typename?: 'NotificationChannel', id: string, name: string, description?: string | null, isEnabled: boolean, channelType: ChannelType, email?: string | null, webhookUrl?: string | null, groupedChannelIds?: Array<string> | null } };

export type DeleteNotificationChannelMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteNotificationChannelMutation = { __typename?: 'Mutation', deleteNotificationChannel: boolean };

export type SendTestNotificationMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type SendTestNotificationMutation = { __typename?: 'Mutation', sendTestNotification: boolean };

export type GetNotificationChannelTestResultsQueryVariables = Exact<{
  id: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetNotificationChannelTestResultsQuery = { __typename?: 'Query', notificationChannelTestResults: Array<{ __typename?: 'NotificationChannelTestResult', id: string, channelId: string, success: boolean, message: string, createdAt: string }> };

export type GetNotificationsQueryVariables = Exact<{
  filter?: InputMaybe<NotificationFilterInput>;
  orderBy?: InputMaybe<NotificationsOrderByInput>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type GetNotificationsQuery = { __typename?: 'Query', notifications: { __typename?: 'PaginatedNotifications', count: number, rows: Array<{ __typename?: 'NotificationEvent', id: string, timeUtc: string, alarmTriggerState: AlarmTriggerState, subject?: string | null, successfulDeliveries: number, failedDeliveries: number, machineId?: string | null, machineName?: string | null, alarmId?: string | null, alarmName?: string | null, signal?: string | null, unit?: string | null, signalCategory?: string | null, thresholdMode?: ThresholdMode | null, thresholdLow?: number | null, thresholdHigh?: number | null, triggerValues?: Array<{ __typename?: 'TriggerValue', mode?: TriggerMode | null, value?: number | null, tags?: Array<{ __typename?: 'TagEntry', key: string, value: string }> | null }> | null, members?: Array<{ __typename?: 'NotificationMember', alarmId?: string | null, alarmName?: string | null, signal?: string | null, unit?: string | null, signalCategory?: string | null, thresholdMode?: ThresholdMode | null, thresholdLow?: number | null, thresholdHigh?: number | null, triggerValues?: Array<{ __typename?: 'TriggerValue', mode?: TriggerMode | null, value?: number | null, tags?: Array<{ __typename?: 'TagEntry', key: string, value: string }> | null }> | null }> | null, notificationDeliveries?: Array<{ __typename?: 'NotificationDelivery', notificationChannelId: string, notificationChannelName?: string | null, success: boolean, errorMessage?: string | null }> | null }>, summary?: { __typename?: 'NotificationsSummary', from?: string | null, to?: string | null, countTriggered?: number | null, countResolved?: number | null, countNotificationsSuccess?: number | null, countNotificationsFail?: number | null } | null } };

export type GetPlantsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPlantsQuery = { __typename?: 'Query', plants: Array<{ __typename?: 'Plant', id: string, ifsId?: string | null, displayName?: string | null, customerId?: string | null, address?: { __typename?: 'Address', id?: string | null, address1?: string | null, address2?: string | null, zipCode?: string | null, city?: string | null, country?: string | null, countryCode?: string | null, state?: string | null, county?: string | null, latitude?: number | null, longitude?: number | null } | null }> };

export type GetPlantQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetPlantQuery = { __typename?: 'Query', plant?: { __typename?: 'Plant', id: string, ifsId?: string | null, displayName?: string | null, customerId?: string | null, address?: { __typename?: 'Address', id?: string | null, address1?: string | null, address2?: string | null, zipCode?: string | null, city?: string | null, country?: string | null, countryCode?: string | null, state?: string | null, county?: string | null, latitude?: number | null, longitude?: number | null } | null } | null };

export type GetPlantByIfsIdQueryVariables = Exact<{
  ifsId: Scalars['String']['input'];
}>;


export type GetPlantByIfsIdQuery = { __typename?: 'Query', plantByIfsId?: { __typename?: 'Plant', id: string, ifsId?: string | null, displayName?: string | null, customerId?: string | null, address?: { __typename?: 'Address', id?: string | null, address1?: string | null, address2?: string | null, zipCode?: string | null, city?: string | null, country?: string | null, countryCode?: string | null, state?: string | null, county?: string | null, latitude?: number | null, longitude?: number | null } | null } | null };

export type GetUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUsersQuery = { __typename?: 'Query', users: Array<{ __typename?: 'User', id: string, email: string, name: string, createdAt: any }> };

export type GetCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, email: string, name: string, createdAt: any, edmsUserId?: string | null } | null };

export type HealthQueryVariables = Exact<{ [key: string]: never; }>;


export type HealthQuery = { __typename?: 'Query', health: { __typename?: 'Health', status: string, timestamp: any, version: string } };

export const AlarmMachineFieldsFragmentDoc = gql`
    fragment AlarmMachineFields on AlarmMachine {
  id
  machineId
  displayName
}
    `;
export const AlarmFieldsFragmentDoc = gql`
    fragment AlarmFields on Alarm {
  id
  isEnabled
  isTriggered
  lastTriggeredAt
  lastResolvedAt
  createdAt
  name
  description
  signalCategory
  signal
  unit
  evalWindowSize
  evalPeriod
  cooldownPeriod
  thresholdLow
  thresholdHigh
  thresholdMode
  triggerMode
  triggerValue
  userId
  machines {
    ...AlarmMachineFields
  }
  alertGroups {
    id
    name
    isTriggered
  }
}
    ${AlarmMachineFieldsFragmentDoc}`;
export const AlertGroupAlarmFieldsFragmentDoc = gql`
    fragment AlertGroupAlarmFields on AlertGroupAlarm {
  id
  name
  isTriggered
}
    `;
export const AlertGroupFieldsFragmentDoc = gql`
    fragment AlertGroupFields on AlertGroup {
  id
  name
  createdAt
  userId
  isTriggered
  isAnyAlarmTriggered
  lastTriggeredAt
  lastResolvedAt
  lastEvaluatedAt
  triggerCount
  notificationSuccessCount
  notificationFailureCount
  alarms {
    ...AlertGroupAlarmFields
  }
  notificationChannelIds
}
    ${AlertGroupAlarmFieldsFragmentDoc}`;
export const MachineDataPointFieldsFragmentDoc = gql`
    fragment MachineDataPointFields on DataPoint {
  timeUtc
  min
  max
  avg
}
    `;
export const MachineDataFieldsFragmentDoc = gql`
    fragment MachineDataFields on MachineData {
  machineId
  startUtc
  endUtc
  signalCategory
  signal
  items {
    ...MachineDataPointFields
  }
  totalCount
  errMsg
}
    ${MachineDataPointFieldsFragmentDoc}`;
export const NotificationChannelFieldsFragmentDoc = gql`
    fragment NotificationChannelFields on NotificationChannel {
  id
  name
  description
  isEnabled
  channelType
  email
  webhookUrl
  groupedChannelIds
}
    `;
export const ProvisionCurrentUserDocument = gql`
    mutation ProvisionCurrentUser {
  provisionCurrentUser {
    status
    message
    retryAfterMs
  }
}
    `;
export type ProvisionCurrentUserMutationFn = Apollo.MutationFunction<ProvisionCurrentUserMutation, ProvisionCurrentUserMutationVariables>;

/**
 * __useProvisionCurrentUserMutation__
 *
 * To run a mutation, you first call `useProvisionCurrentUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProvisionCurrentUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [provisionCurrentUserMutation, { data, loading, error }] = useProvisionCurrentUserMutation({
 *   variables: {
 *   },
 * });
 */
export function useProvisionCurrentUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProvisionCurrentUserMutation, ProvisionCurrentUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProvisionCurrentUserMutation, ProvisionCurrentUserMutationVariables>(ProvisionCurrentUserDocument, options);
      }
export type ProvisionCurrentUserMutationHookResult = ReturnType<typeof useProvisionCurrentUserMutation>;
export type ProvisionCurrentUserMutationResult = Apollo.MutationResult<ProvisionCurrentUserMutation>;
export type ProvisionCurrentUserMutationOptions = Apollo.BaseMutationOptions<ProvisionCurrentUserMutation, ProvisionCurrentUserMutationVariables>;
export const GetAlarmsDocument = gql`
    query GetAlarms($orderBy: AlarmsOrderByInput, $filter: AlarmsFilterInput, $pagination: PaginationInput) {
  alarms(orderBy: $orderBy, filter: $filter, pagination: $pagination) {
    count
    rows {
      ...AlarmFields
    }
  }
}
    ${AlarmFieldsFragmentDoc}`;

/**
 * __useGetAlarmsQuery__
 *
 * To run a query within a React component, call `useGetAlarmsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlarmsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAlarmsQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetAlarmsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAlarmsQuery, GetAlarmsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAlarmsQuery, GetAlarmsQueryVariables>(GetAlarmsDocument, options);
      }
export function useGetAlarmsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAlarmsQuery, GetAlarmsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAlarmsQuery, GetAlarmsQueryVariables>(GetAlarmsDocument, options);
        }
// @ts-ignore
export function useGetAlarmsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetAlarmsQuery, GetAlarmsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetAlarmsQuery, GetAlarmsQueryVariables>;
export function useGetAlarmsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAlarmsQuery, GetAlarmsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetAlarmsQuery | undefined, GetAlarmsQueryVariables>;
export function useGetAlarmsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAlarmsQuery, GetAlarmsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAlarmsQuery, GetAlarmsQueryVariables>(GetAlarmsDocument, options);
        }
export type GetAlarmsQueryHookResult = ReturnType<typeof useGetAlarmsQuery>;
export type GetAlarmsLazyQueryHookResult = ReturnType<typeof useGetAlarmsLazyQuery>;
export type GetAlarmsSuspenseQueryHookResult = ReturnType<typeof useGetAlarmsSuspenseQuery>;
export type GetAlarmsQueryResult = Apollo.QueryResult<GetAlarmsQuery, GetAlarmsQueryVariables>;
export const GetAlarmDocument = gql`
    query GetAlarm($id: String!) {
  alarm(id: $id) {
    ...AlarmFields
  }
}
    ${AlarmFieldsFragmentDoc}`;

/**
 * __useGetAlarmQuery__
 *
 * To run a query within a React component, call `useGetAlarmQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlarmQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAlarmQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAlarmQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAlarmQuery, GetAlarmQueryVariables> & ({ variables: GetAlarmQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAlarmQuery, GetAlarmQueryVariables>(GetAlarmDocument, options);
      }
export function useGetAlarmLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAlarmQuery, GetAlarmQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAlarmQuery, GetAlarmQueryVariables>(GetAlarmDocument, options);
        }
// @ts-ignore
export function useGetAlarmSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetAlarmQuery, GetAlarmQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetAlarmQuery, GetAlarmQueryVariables>;
export function useGetAlarmSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAlarmQuery, GetAlarmQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetAlarmQuery | undefined, GetAlarmQueryVariables>;
export function useGetAlarmSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAlarmQuery, GetAlarmQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAlarmQuery, GetAlarmQueryVariables>(GetAlarmDocument, options);
        }
export type GetAlarmQueryHookResult = ReturnType<typeof useGetAlarmQuery>;
export type GetAlarmLazyQueryHookResult = ReturnType<typeof useGetAlarmLazyQuery>;
export type GetAlarmSuspenseQueryHookResult = ReturnType<typeof useGetAlarmSuspenseQuery>;
export type GetAlarmQueryResult = Apollo.QueryResult<GetAlarmQuery, GetAlarmQueryVariables>;
export const CreateAlarmDocument = gql`
    mutation CreateAlarm($input: CreateAlarmInput!) {
  createAlarm(input: $input) {
    ...AlarmFields
  }
}
    ${AlarmFieldsFragmentDoc}`;
export type CreateAlarmMutationFn = Apollo.MutationFunction<CreateAlarmMutation, CreateAlarmMutationVariables>;

/**
 * __useCreateAlarmMutation__
 *
 * To run a mutation, you first call `useCreateAlarmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAlarmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAlarmMutation, { data, loading, error }] = useCreateAlarmMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAlarmMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateAlarmMutation, CreateAlarmMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateAlarmMutation, CreateAlarmMutationVariables>(CreateAlarmDocument, options);
      }
export type CreateAlarmMutationHookResult = ReturnType<typeof useCreateAlarmMutation>;
export type CreateAlarmMutationResult = Apollo.MutationResult<CreateAlarmMutation>;
export type CreateAlarmMutationOptions = Apollo.BaseMutationOptions<CreateAlarmMutation, CreateAlarmMutationVariables>;
export const UpdateAlarmDocument = gql`
    mutation UpdateAlarm($id: String!, $input: UpdateAlarmInput!) {
  updateAlarm(id: $id, input: $input) {
    ...AlarmFields
  }
}
    ${AlarmFieldsFragmentDoc}`;
export type UpdateAlarmMutationFn = Apollo.MutationFunction<UpdateAlarmMutation, UpdateAlarmMutationVariables>;

/**
 * __useUpdateAlarmMutation__
 *
 * To run a mutation, you first call `useUpdateAlarmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAlarmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAlarmMutation, { data, loading, error }] = useUpdateAlarmMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAlarmMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAlarmMutation, UpdateAlarmMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateAlarmMutation, UpdateAlarmMutationVariables>(UpdateAlarmDocument, options);
      }
export type UpdateAlarmMutationHookResult = ReturnType<typeof useUpdateAlarmMutation>;
export type UpdateAlarmMutationResult = Apollo.MutationResult<UpdateAlarmMutation>;
export type UpdateAlarmMutationOptions = Apollo.BaseMutationOptions<UpdateAlarmMutation, UpdateAlarmMutationVariables>;
export const SetAlarmEnabledDocument = gql`
    mutation SetAlarmEnabled($id: String!, $isEnabled: Boolean!) {
  updateAlarm(id: $id, input: {isEnabled: $isEnabled}) {
    id
    isEnabled
  }
}
    `;
export type SetAlarmEnabledMutationFn = Apollo.MutationFunction<SetAlarmEnabledMutation, SetAlarmEnabledMutationVariables>;

/**
 * __useSetAlarmEnabledMutation__
 *
 * To run a mutation, you first call `useSetAlarmEnabledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAlarmEnabledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAlarmEnabledMutation, { data, loading, error }] = useSetAlarmEnabledMutation({
 *   variables: {
 *      id: // value for 'id'
 *      isEnabled: // value for 'isEnabled'
 *   },
 * });
 */
export function useSetAlarmEnabledMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetAlarmEnabledMutation, SetAlarmEnabledMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetAlarmEnabledMutation, SetAlarmEnabledMutationVariables>(SetAlarmEnabledDocument, options);
      }
export type SetAlarmEnabledMutationHookResult = ReturnType<typeof useSetAlarmEnabledMutation>;
export type SetAlarmEnabledMutationResult = Apollo.MutationResult<SetAlarmEnabledMutation>;
export type SetAlarmEnabledMutationOptions = Apollo.BaseMutationOptions<SetAlarmEnabledMutation, SetAlarmEnabledMutationVariables>;
export const DeleteAlarmDocument = gql`
    mutation DeleteAlarm($id: String!) {
  deleteAlarm(id: $id)
}
    `;
export type DeleteAlarmMutationFn = Apollo.MutationFunction<DeleteAlarmMutation, DeleteAlarmMutationVariables>;

/**
 * __useDeleteAlarmMutation__
 *
 * To run a mutation, you first call `useDeleteAlarmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAlarmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAlarmMutation, { data, loading, error }] = useDeleteAlarmMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAlarmMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteAlarmMutation, DeleteAlarmMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteAlarmMutation, DeleteAlarmMutationVariables>(DeleteAlarmDocument, options);
      }
export type DeleteAlarmMutationHookResult = ReturnType<typeof useDeleteAlarmMutation>;
export type DeleteAlarmMutationResult = Apollo.MutationResult<DeleteAlarmMutation>;
export type DeleteAlarmMutationOptions = Apollo.BaseMutationOptions<DeleteAlarmMutation, DeleteAlarmMutationVariables>;
export const GetAlertGroupsDocument = gql`
    query GetAlertGroups($orderBy: AlertGroupsOrderByInput, $filter: AlertGroupsFilterInput, $pagination: PaginationInput) {
  alertGroups(orderBy: $orderBy, filter: $filter, pagination: $pagination) {
    count
    rows {
      ...AlertGroupFields
    }
  }
}
    ${AlertGroupFieldsFragmentDoc}`;

/**
 * __useGetAlertGroupsQuery__
 *
 * To run a query within a React component, call `useGetAlertGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlertGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAlertGroupsQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetAlertGroupsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAlertGroupsQuery, GetAlertGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAlertGroupsQuery, GetAlertGroupsQueryVariables>(GetAlertGroupsDocument, options);
      }
export function useGetAlertGroupsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAlertGroupsQuery, GetAlertGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAlertGroupsQuery, GetAlertGroupsQueryVariables>(GetAlertGroupsDocument, options);
        }
// @ts-ignore
export function useGetAlertGroupsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetAlertGroupsQuery, GetAlertGroupsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetAlertGroupsQuery, GetAlertGroupsQueryVariables>;
export function useGetAlertGroupsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAlertGroupsQuery, GetAlertGroupsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetAlertGroupsQuery | undefined, GetAlertGroupsQueryVariables>;
export function useGetAlertGroupsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAlertGroupsQuery, GetAlertGroupsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAlertGroupsQuery, GetAlertGroupsQueryVariables>(GetAlertGroupsDocument, options);
        }
export type GetAlertGroupsQueryHookResult = ReturnType<typeof useGetAlertGroupsQuery>;
export type GetAlertGroupsLazyQueryHookResult = ReturnType<typeof useGetAlertGroupsLazyQuery>;
export type GetAlertGroupsSuspenseQueryHookResult = ReturnType<typeof useGetAlertGroupsSuspenseQuery>;
export type GetAlertGroupsQueryResult = Apollo.QueryResult<GetAlertGroupsQuery, GetAlertGroupsQueryVariables>;
export const GetAlertGroupDocument = gql`
    query GetAlertGroup($id: String!) {
  alertGroup(id: $id) {
    ...AlertGroupFields
  }
}
    ${AlertGroupFieldsFragmentDoc}`;

/**
 * __useGetAlertGroupQuery__
 *
 * To run a query within a React component, call `useGetAlertGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAlertGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAlertGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAlertGroupQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAlertGroupQuery, GetAlertGroupQueryVariables> & ({ variables: GetAlertGroupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAlertGroupQuery, GetAlertGroupQueryVariables>(GetAlertGroupDocument, options);
      }
export function useGetAlertGroupLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAlertGroupQuery, GetAlertGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAlertGroupQuery, GetAlertGroupQueryVariables>(GetAlertGroupDocument, options);
        }
// @ts-ignore
export function useGetAlertGroupSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetAlertGroupQuery, GetAlertGroupQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetAlertGroupQuery, GetAlertGroupQueryVariables>;
export function useGetAlertGroupSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAlertGroupQuery, GetAlertGroupQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetAlertGroupQuery | undefined, GetAlertGroupQueryVariables>;
export function useGetAlertGroupSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAlertGroupQuery, GetAlertGroupQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAlertGroupQuery, GetAlertGroupQueryVariables>(GetAlertGroupDocument, options);
        }
export type GetAlertGroupQueryHookResult = ReturnType<typeof useGetAlertGroupQuery>;
export type GetAlertGroupLazyQueryHookResult = ReturnType<typeof useGetAlertGroupLazyQuery>;
export type GetAlertGroupSuspenseQueryHookResult = ReturnType<typeof useGetAlertGroupSuspenseQuery>;
export type GetAlertGroupQueryResult = Apollo.QueryResult<GetAlertGroupQuery, GetAlertGroupQueryVariables>;
export const CreateAlertGroupDocument = gql`
    mutation CreateAlertGroup($input: CreateAlertGroupInput!) {
  createAlertGroup(input: $input) {
    ...AlertGroupFields
  }
}
    ${AlertGroupFieldsFragmentDoc}`;
export type CreateAlertGroupMutationFn = Apollo.MutationFunction<CreateAlertGroupMutation, CreateAlertGroupMutationVariables>;

/**
 * __useCreateAlertGroupMutation__
 *
 * To run a mutation, you first call `useCreateAlertGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAlertGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAlertGroupMutation, { data, loading, error }] = useCreateAlertGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAlertGroupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateAlertGroupMutation, CreateAlertGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateAlertGroupMutation, CreateAlertGroupMutationVariables>(CreateAlertGroupDocument, options);
      }
export type CreateAlertGroupMutationHookResult = ReturnType<typeof useCreateAlertGroupMutation>;
export type CreateAlertGroupMutationResult = Apollo.MutationResult<CreateAlertGroupMutation>;
export type CreateAlertGroupMutationOptions = Apollo.BaseMutationOptions<CreateAlertGroupMutation, CreateAlertGroupMutationVariables>;
export const UpdateAlertGroupDocument = gql`
    mutation UpdateAlertGroup($id: String!, $input: UpdateAlertGroupInput!) {
  updateAlertGroup(id: $id, input: $input) {
    ...AlertGroupFields
  }
}
    ${AlertGroupFieldsFragmentDoc}`;
export type UpdateAlertGroupMutationFn = Apollo.MutationFunction<UpdateAlertGroupMutation, UpdateAlertGroupMutationVariables>;

/**
 * __useUpdateAlertGroupMutation__
 *
 * To run a mutation, you first call `useUpdateAlertGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAlertGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAlertGroupMutation, { data, loading, error }] = useUpdateAlertGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAlertGroupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAlertGroupMutation, UpdateAlertGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateAlertGroupMutation, UpdateAlertGroupMutationVariables>(UpdateAlertGroupDocument, options);
      }
export type UpdateAlertGroupMutationHookResult = ReturnType<typeof useUpdateAlertGroupMutation>;
export type UpdateAlertGroupMutationResult = Apollo.MutationResult<UpdateAlertGroupMutation>;
export type UpdateAlertGroupMutationOptions = Apollo.BaseMutationOptions<UpdateAlertGroupMutation, UpdateAlertGroupMutationVariables>;
export const DeleteAlertGroupDocument = gql`
    mutation DeleteAlertGroup($id: String!) {
  deleteAlertGroup(id: $id)
}
    `;
export type DeleteAlertGroupMutationFn = Apollo.MutationFunction<DeleteAlertGroupMutation, DeleteAlertGroupMutationVariables>;

/**
 * __useDeleteAlertGroupMutation__
 *
 * To run a mutation, you first call `useDeleteAlertGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAlertGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAlertGroupMutation, { data, loading, error }] = useDeleteAlertGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAlertGroupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteAlertGroupMutation, DeleteAlertGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteAlertGroupMutation, DeleteAlertGroupMutationVariables>(DeleteAlertGroupDocument, options);
      }
export type DeleteAlertGroupMutationHookResult = ReturnType<typeof useDeleteAlertGroupMutation>;
export type DeleteAlertGroupMutationResult = Apollo.MutationResult<DeleteAlertGroupMutation>;
export type DeleteAlertGroupMutationOptions = Apollo.BaseMutationOptions<DeleteAlertGroupMutation, DeleteAlertGroupMutationVariables>;
export const TestAlertGroupDocument = gql`
    mutation TestAlertGroup($id: String!) {
  testAlertGroup(id: $id)
}
    `;
export type TestAlertGroupMutationFn = Apollo.MutationFunction<TestAlertGroupMutation, TestAlertGroupMutationVariables>;

/**
 * __useTestAlertGroupMutation__
 *
 * To run a mutation, you first call `useTestAlertGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTestAlertGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [testAlertGroupMutation, { data, loading, error }] = useTestAlertGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTestAlertGroupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<TestAlertGroupMutation, TestAlertGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<TestAlertGroupMutation, TestAlertGroupMutationVariables>(TestAlertGroupDocument, options);
      }
export type TestAlertGroupMutationHookResult = ReturnType<typeof useTestAlertGroupMutation>;
export type TestAlertGroupMutationResult = Apollo.MutationResult<TestAlertGroupMutation>;
export type TestAlertGroupMutationOptions = Apollo.BaseMutationOptions<TestAlertGroupMutation, TestAlertGroupMutationVariables>;
export const GetCustomersDocument = gql`
    query GetCustomers($search: String) {
  customers(search: $search) {
    id
    ifsId
    name
    displayName
    defaultLanguage
    country
    countryCode
    representative
    customerCategory
  }
}
    `;

/**
 * __useGetCustomersQuery__
 *
 * To run a query within a React component, call `useGetCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomersQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetCustomersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCustomersQuery, GetCustomersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCustomersQuery, GetCustomersQueryVariables>(GetCustomersDocument, options);
      }
export function useGetCustomersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCustomersQuery, GetCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCustomersQuery, GetCustomersQueryVariables>(GetCustomersDocument, options);
        }
// @ts-ignore
export function useGetCustomersSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetCustomersQuery, GetCustomersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetCustomersQuery, GetCustomersQueryVariables>;
export function useGetCustomersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCustomersQuery, GetCustomersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetCustomersQuery | undefined, GetCustomersQueryVariables>;
export function useGetCustomersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCustomersQuery, GetCustomersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetCustomersQuery, GetCustomersQueryVariables>(GetCustomersDocument, options);
        }
export type GetCustomersQueryHookResult = ReturnType<typeof useGetCustomersQuery>;
export type GetCustomersLazyQueryHookResult = ReturnType<typeof useGetCustomersLazyQuery>;
export type GetCustomersSuspenseQueryHookResult = ReturnType<typeof useGetCustomersSuspenseQuery>;
export type GetCustomersQueryResult = Apollo.QueryResult<GetCustomersQuery, GetCustomersQueryVariables>;
export const GetCustomerDocument = gql`
    query GetCustomer($id: String!) {
  customer(id: $id) {
    id
    ifsId
    name
    displayName
    defaultLanguage
    country
    countryCode
    representative
    customerCategory
  }
}
    `;

/**
 * __useGetCustomerQuery__
 *
 * To run a query within a React component, call `useGetCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCustomerQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetCustomerQuery, GetCustomerQueryVariables> & ({ variables: GetCustomerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCustomerQuery, GetCustomerQueryVariables>(GetCustomerDocument, options);
      }
export function useGetCustomerLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCustomerQuery, GetCustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCustomerQuery, GetCustomerQueryVariables>(GetCustomerDocument, options);
        }
// @ts-ignore
export function useGetCustomerSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetCustomerQuery, GetCustomerQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetCustomerQuery, GetCustomerQueryVariables>;
export function useGetCustomerSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCustomerQuery, GetCustomerQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetCustomerQuery | undefined, GetCustomerQueryVariables>;
export function useGetCustomerSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCustomerQuery, GetCustomerQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetCustomerQuery, GetCustomerQueryVariables>(GetCustomerDocument, options);
        }
export type GetCustomerQueryHookResult = ReturnType<typeof useGetCustomerQuery>;
export type GetCustomerLazyQueryHookResult = ReturnType<typeof useGetCustomerLazyQuery>;
export type GetCustomerSuspenseQueryHookResult = ReturnType<typeof useGetCustomerSuspenseQuery>;
export type GetCustomerQueryResult = Apollo.QueryResult<GetCustomerQuery, GetCustomerQueryVariables>;
export const GetCustomerByIfsIdDocument = gql`
    query GetCustomerByIfsId($ifsId: String!) {
  customerByIfsId(ifsId: $ifsId) {
    id
    ifsId
    name
    displayName
    defaultLanguage
    country
    countryCode
    representative
    customerCategory
  }
}
    `;

/**
 * __useGetCustomerByIfsIdQuery__
 *
 * To run a query within a React component, call `useGetCustomerByIfsIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerByIfsIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerByIfsIdQuery({
 *   variables: {
 *      ifsId: // value for 'ifsId'
 *   },
 * });
 */
export function useGetCustomerByIfsIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetCustomerByIfsIdQuery, GetCustomerByIfsIdQueryVariables> & ({ variables: GetCustomerByIfsIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCustomerByIfsIdQuery, GetCustomerByIfsIdQueryVariables>(GetCustomerByIfsIdDocument, options);
      }
export function useGetCustomerByIfsIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCustomerByIfsIdQuery, GetCustomerByIfsIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCustomerByIfsIdQuery, GetCustomerByIfsIdQueryVariables>(GetCustomerByIfsIdDocument, options);
        }
// @ts-ignore
export function useGetCustomerByIfsIdSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetCustomerByIfsIdQuery, GetCustomerByIfsIdQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetCustomerByIfsIdQuery, GetCustomerByIfsIdQueryVariables>;
export function useGetCustomerByIfsIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCustomerByIfsIdQuery, GetCustomerByIfsIdQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetCustomerByIfsIdQuery | undefined, GetCustomerByIfsIdQueryVariables>;
export function useGetCustomerByIfsIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCustomerByIfsIdQuery, GetCustomerByIfsIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetCustomerByIfsIdQuery, GetCustomerByIfsIdQueryVariables>(GetCustomerByIfsIdDocument, options);
        }
export type GetCustomerByIfsIdQueryHookResult = ReturnType<typeof useGetCustomerByIfsIdQuery>;
export type GetCustomerByIfsIdLazyQueryHookResult = ReturnType<typeof useGetCustomerByIfsIdLazyQuery>;
export type GetCustomerByIfsIdSuspenseQueryHookResult = ReturnType<typeof useGetCustomerByIfsIdSuspenseQuery>;
export type GetCustomerByIfsIdQueryResult = Apollo.QueryResult<GetCustomerByIfsIdQuery, GetCustomerByIfsIdQueryVariables>;
export const GetMachinesAvailableSignalsDocument = gql`
    query GetMachinesAvailableSignals($ids: [String!]!) {
  machinesSignals: machines(filter: {machineIds: $ids}, pagination: {limit: 1000}) {
    rows {
      id
      machineId
      displayName
      availableSignals {
        lastTimeUtc
        signals {
          category
          signals {
            signal
            unit
            lastTimeUtc
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetMachinesAvailableSignalsQuery__
 *
 * To run a query within a React component, call `useGetMachinesAvailableSignalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMachinesAvailableSignalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMachinesAvailableSignalsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetMachinesAvailableSignalsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetMachinesAvailableSignalsQuery, GetMachinesAvailableSignalsQueryVariables> & ({ variables: GetMachinesAvailableSignalsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMachinesAvailableSignalsQuery, GetMachinesAvailableSignalsQueryVariables>(GetMachinesAvailableSignalsDocument, options);
      }
export function useGetMachinesAvailableSignalsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMachinesAvailableSignalsQuery, GetMachinesAvailableSignalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMachinesAvailableSignalsQuery, GetMachinesAvailableSignalsQueryVariables>(GetMachinesAvailableSignalsDocument, options);
        }
// @ts-ignore
export function useGetMachinesAvailableSignalsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetMachinesAvailableSignalsQuery, GetMachinesAvailableSignalsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetMachinesAvailableSignalsQuery, GetMachinesAvailableSignalsQueryVariables>;
export function useGetMachinesAvailableSignalsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetMachinesAvailableSignalsQuery, GetMachinesAvailableSignalsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetMachinesAvailableSignalsQuery | undefined, GetMachinesAvailableSignalsQueryVariables>;
export function useGetMachinesAvailableSignalsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetMachinesAvailableSignalsQuery, GetMachinesAvailableSignalsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetMachinesAvailableSignalsQuery, GetMachinesAvailableSignalsQueryVariables>(GetMachinesAvailableSignalsDocument, options);
        }
export type GetMachinesAvailableSignalsQueryHookResult = ReturnType<typeof useGetMachinesAvailableSignalsQuery>;
export type GetMachinesAvailableSignalsLazyQueryHookResult = ReturnType<typeof useGetMachinesAvailableSignalsLazyQuery>;
export type GetMachinesAvailableSignalsSuspenseQueryHookResult = ReturnType<typeof useGetMachinesAvailableSignalsSuspenseQuery>;
export type GetMachinesAvailableSignalsQueryResult = Apollo.QueryResult<GetMachinesAvailableSignalsQuery, GetMachinesAvailableSignalsQueryVariables>;
export const GetMachineMetricDataDocument = gql`
    query GetMachineMetricData($input: MetricQueryInput!) {
  getMachineMetricData(input: $input) {
    isSingleMachine
    dataPoints {
      time
      min
      max
      average
      label
    }
    rangeData {
      time
      min
      max
      average
      label
    }
    machineIds
    metricType
    timespan
    unit
    threshold
  }
}
    `;

/**
 * __useGetMachineMetricDataQuery__
 *
 * To run a query within a React component, call `useGetMachineMetricDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMachineMetricDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMachineMetricDataQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetMachineMetricDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetMachineMetricDataQuery, GetMachineMetricDataQueryVariables> & ({ variables: GetMachineMetricDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMachineMetricDataQuery, GetMachineMetricDataQueryVariables>(GetMachineMetricDataDocument, options);
      }
export function useGetMachineMetricDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMachineMetricDataQuery, GetMachineMetricDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMachineMetricDataQuery, GetMachineMetricDataQueryVariables>(GetMachineMetricDataDocument, options);
        }
// @ts-ignore
export function useGetMachineMetricDataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetMachineMetricDataQuery, GetMachineMetricDataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetMachineMetricDataQuery, GetMachineMetricDataQueryVariables>;
export function useGetMachineMetricDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetMachineMetricDataQuery, GetMachineMetricDataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetMachineMetricDataQuery | undefined, GetMachineMetricDataQueryVariables>;
export function useGetMachineMetricDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetMachineMetricDataQuery, GetMachineMetricDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetMachineMetricDataQuery, GetMachineMetricDataQueryVariables>(GetMachineMetricDataDocument, options);
        }
export type GetMachineMetricDataQueryHookResult = ReturnType<typeof useGetMachineMetricDataQuery>;
export type GetMachineMetricDataLazyQueryHookResult = ReturnType<typeof useGetMachineMetricDataLazyQuery>;
export type GetMachineMetricDataSuspenseQueryHookResult = ReturnType<typeof useGetMachineMetricDataSuspenseQuery>;
export type GetMachineMetricDataQueryResult = Apollo.QueryResult<GetMachineMetricDataQuery, GetMachineMetricDataQueryVariables>;
export const GetMachinesDocument = gql`
    query GetMachines($filter: MachinesFilterInput, $orderBy: MachinesOrderByInput, $pagination: PaginationInput) {
  machines(filter: $filter, orderBy: $orderBy, pagination: $pagination) {
    count
    rows {
      id
      machineId
      displayName
      serial
      partNumber
      soid
      family
      plant {
        id
        displayName
      }
      customer {
        id
        ifsId
        name
        displayName
        defaultLanguage
        country
        countryCode
        representative
        customerCategory
      }
      edgeDevice {
        id
        deviceId
        displayName
        connectionStatus
      }
      address {
        id
        address1
        address2
        zipCode
        city
        country
        countryCode
        state
        county
        latitude
        longitude
      }
      state {
        timeUtc
        state
        isSynthetic
        lastRecordedState
        lastRecordedStateTimeUtc
      }
      alerts {
        id
        alarmName
        isTriggered
        lastTriggeredAt
        lastResolvedAt
      }
    }
  }
}
    `;

/**
 * __useGetMachinesQuery__
 *
 * To run a query within a React component, call `useGetMachinesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMachinesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMachinesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetMachinesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMachinesQuery, GetMachinesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMachinesQuery, GetMachinesQueryVariables>(GetMachinesDocument, options);
      }
export function useGetMachinesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMachinesQuery, GetMachinesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMachinesQuery, GetMachinesQueryVariables>(GetMachinesDocument, options);
        }
// @ts-ignore
export function useGetMachinesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetMachinesQuery, GetMachinesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetMachinesQuery, GetMachinesQueryVariables>;
export function useGetMachinesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetMachinesQuery, GetMachinesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetMachinesQuery | undefined, GetMachinesQueryVariables>;
export function useGetMachinesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetMachinesQuery, GetMachinesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetMachinesQuery, GetMachinesQueryVariables>(GetMachinesDocument, options);
        }
export type GetMachinesQueryHookResult = ReturnType<typeof useGetMachinesQuery>;
export type GetMachinesLazyQueryHookResult = ReturnType<typeof useGetMachinesLazyQuery>;
export type GetMachinesSuspenseQueryHookResult = ReturnType<typeof useGetMachinesSuspenseQuery>;
export type GetMachinesQueryResult = Apollo.QueryResult<GetMachinesQuery, GetMachinesQueryVariables>;
export const GetMachineDocument = gql`
    query GetMachine($id: String!) {
  machine(id: $id) {
    id
    machineId
    displayName
    serial
    partNumber
    soid
    family
    plant {
      id
      displayName
    }
    customer {
      id
      ifsId
      name
      displayName
      defaultLanguage
      country
      countryCode
      representative
      customerCategory
    }
    edgeDevice {
      id
      deviceId
      displayName
      connectionStatus
    }
    address {
      id
      address1
      address2
      zipCode
      city
      country
      countryCode
      state
      county
      latitude
      longitude
    }
    state {
      timeUtc
      state
      isSynthetic
      lastRecordedState
      lastRecordedStateTimeUtc
    }
    availableSignals {
      lastTimeUtc
      signals {
        category
        signals {
          signal
          unit
          lastTimeUtc
          dimensions
        }
      }
    }
  }
}
    `;

/**
 * __useGetMachineQuery__
 *
 * To run a query within a React component, call `useGetMachineQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMachineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMachineQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMachineQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetMachineQuery, GetMachineQueryVariables> & ({ variables: GetMachineQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMachineQuery, GetMachineQueryVariables>(GetMachineDocument, options);
      }
export function useGetMachineLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMachineQuery, GetMachineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMachineQuery, GetMachineQueryVariables>(GetMachineDocument, options);
        }
// @ts-ignore
export function useGetMachineSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetMachineQuery, GetMachineQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetMachineQuery, GetMachineQueryVariables>;
export function useGetMachineSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetMachineQuery, GetMachineQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetMachineQuery | undefined, GetMachineQueryVariables>;
export function useGetMachineSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetMachineQuery, GetMachineQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetMachineQuery, GetMachineQueryVariables>(GetMachineDocument, options);
        }
export type GetMachineQueryHookResult = ReturnType<typeof useGetMachineQuery>;
export type GetMachineLazyQueryHookResult = ReturnType<typeof useGetMachineLazyQuery>;
export type GetMachineSuspenseQueryHookResult = ReturnType<typeof useGetMachineSuspenseQuery>;
export type GetMachineQueryResult = Apollo.QueryResult<GetMachineQuery, GetMachineQueryVariables>;
export const GetMachineDataDocument = gql`
    query GetMachineData($id: String!, $signalCategory: String, $signal: String, $timeRange: String, $numDataPoints: Float) {
  machineData(
    id: $id
    signalCategory: $signalCategory
    signal: $signal
    timeRange: $timeRange
    numDataPoints: $numDataPoints
  ) {
    ...MachineDataFields
  }
}
    ${MachineDataFieldsFragmentDoc}`;

/**
 * __useGetMachineDataQuery__
 *
 * To run a query within a React component, call `useGetMachineDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMachineDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMachineDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *      signalCategory: // value for 'signalCategory'
 *      signal: // value for 'signal'
 *      timeRange: // value for 'timeRange'
 *      numDataPoints: // value for 'numDataPoints'
 *   },
 * });
 */
export function useGetMachineDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetMachineDataQuery, GetMachineDataQueryVariables> & ({ variables: GetMachineDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMachineDataQuery, GetMachineDataQueryVariables>(GetMachineDataDocument, options);
      }
export function useGetMachineDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMachineDataQuery, GetMachineDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMachineDataQuery, GetMachineDataQueryVariables>(GetMachineDataDocument, options);
        }
// @ts-ignore
export function useGetMachineDataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetMachineDataQuery, GetMachineDataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetMachineDataQuery, GetMachineDataQueryVariables>;
export function useGetMachineDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetMachineDataQuery, GetMachineDataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetMachineDataQuery | undefined, GetMachineDataQueryVariables>;
export function useGetMachineDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetMachineDataQuery, GetMachineDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetMachineDataQuery, GetMachineDataQueryVariables>(GetMachineDataDocument, options);
        }
export type GetMachineDataQueryHookResult = ReturnType<typeof useGetMachineDataQuery>;
export type GetMachineDataLazyQueryHookResult = ReturnType<typeof useGetMachineDataLazyQuery>;
export type GetMachineDataSuspenseQueryHookResult = ReturnType<typeof useGetMachineDataSuspenseQuery>;
export type GetMachineDataQueryResult = Apollo.QueryResult<GetMachineDataQuery, GetMachineDataQueryVariables>;
export const GetMachineGroupedDataDocument = gql`
    query GetMachineGroupedData($id: String!, $signalCategory: String!, $signal: String!, $dimensions: [String!]!, $overTime: Boolean!, $numDataPoints: Float, $startTime: String!, $endTime: String!) {
  machineData(
    id: $id
    signalCategory: $signalCategory
    signal: $signal
    dimensions: $dimensions
    overTime: $overTime
    numDataPoints: $numDataPoints
    startTime: $startTime
    endTime: $endTime
  ) {
    machineId
    signalCategory
    signal
    errMsg
    items {
      timeUtc
      sum
      count
      dimensions {
        name
        value
      }
    }
  }
}
    `;

/**
 * __useGetMachineGroupedDataQuery__
 *
 * To run a query within a React component, call `useGetMachineGroupedDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMachineGroupedDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMachineGroupedDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *      signalCategory: // value for 'signalCategory'
 *      signal: // value for 'signal'
 *      dimensions: // value for 'dimensions'
 *      overTime: // value for 'overTime'
 *      numDataPoints: // value for 'numDataPoints'
 *      startTime: // value for 'startTime'
 *      endTime: // value for 'endTime'
 *   },
 * });
 */
export function useGetMachineGroupedDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetMachineGroupedDataQuery, GetMachineGroupedDataQueryVariables> & ({ variables: GetMachineGroupedDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMachineGroupedDataQuery, GetMachineGroupedDataQueryVariables>(GetMachineGroupedDataDocument, options);
      }
export function useGetMachineGroupedDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMachineGroupedDataQuery, GetMachineGroupedDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMachineGroupedDataQuery, GetMachineGroupedDataQueryVariables>(GetMachineGroupedDataDocument, options);
        }
// @ts-ignore
export function useGetMachineGroupedDataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetMachineGroupedDataQuery, GetMachineGroupedDataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetMachineGroupedDataQuery, GetMachineGroupedDataQueryVariables>;
export function useGetMachineGroupedDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetMachineGroupedDataQuery, GetMachineGroupedDataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetMachineGroupedDataQuery | undefined, GetMachineGroupedDataQueryVariables>;
export function useGetMachineGroupedDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetMachineGroupedDataQuery, GetMachineGroupedDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetMachineGroupedDataQuery, GetMachineGroupedDataQueryVariables>(GetMachineGroupedDataDocument, options);
        }
export type GetMachineGroupedDataQueryHookResult = ReturnType<typeof useGetMachineGroupedDataQuery>;
export type GetMachineGroupedDataLazyQueryHookResult = ReturnType<typeof useGetMachineGroupedDataLazyQuery>;
export type GetMachineGroupedDataSuspenseQueryHookResult = ReturnType<typeof useGetMachineGroupedDataSuspenseQuery>;
export type GetMachineGroupedDataQueryResult = Apollo.QueryResult<GetMachineGroupedDataQuery, GetMachineGroupedDataQueryVariables>;
export const GetNotificationChannelsDocument = gql`
    query GetNotificationChannels($filter: NotificationChannelsFilterInput, $orderBy: NotificationChannelsOrderByInput, $pagination: PaginationInput) {
  notificationChannels(
    filter: $filter
    orderBy: $orderBy
    pagination: $pagination
  ) {
    count
    rows {
      ...NotificationChannelFields
    }
  }
}
    ${NotificationChannelFieldsFragmentDoc}`;

/**
 * __useGetNotificationChannelsQuery__
 *
 * To run a query within a React component, call `useGetNotificationChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationChannelsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetNotificationChannelsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetNotificationChannelsQuery, GetNotificationChannelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetNotificationChannelsQuery, GetNotificationChannelsQueryVariables>(GetNotificationChannelsDocument, options);
      }
export function useGetNotificationChannelsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNotificationChannelsQuery, GetNotificationChannelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetNotificationChannelsQuery, GetNotificationChannelsQueryVariables>(GetNotificationChannelsDocument, options);
        }
// @ts-ignore
export function useGetNotificationChannelsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetNotificationChannelsQuery, GetNotificationChannelsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetNotificationChannelsQuery, GetNotificationChannelsQueryVariables>;
export function useGetNotificationChannelsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetNotificationChannelsQuery, GetNotificationChannelsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetNotificationChannelsQuery | undefined, GetNotificationChannelsQueryVariables>;
export function useGetNotificationChannelsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetNotificationChannelsQuery, GetNotificationChannelsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetNotificationChannelsQuery, GetNotificationChannelsQueryVariables>(GetNotificationChannelsDocument, options);
        }
export type GetNotificationChannelsQueryHookResult = ReturnType<typeof useGetNotificationChannelsQuery>;
export type GetNotificationChannelsLazyQueryHookResult = ReturnType<typeof useGetNotificationChannelsLazyQuery>;
export type GetNotificationChannelsSuspenseQueryHookResult = ReturnType<typeof useGetNotificationChannelsSuspenseQuery>;
export type GetNotificationChannelsQueryResult = Apollo.QueryResult<GetNotificationChannelsQuery, GetNotificationChannelsQueryVariables>;
export const GetNotificationChannelDocument = gql`
    query GetNotificationChannel($id: String!) {
  notificationChannel(id: $id) {
    ...NotificationChannelFields
  }
}
    ${NotificationChannelFieldsFragmentDoc}`;

/**
 * __useGetNotificationChannelQuery__
 *
 * To run a query within a React component, call `useGetNotificationChannelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationChannelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationChannelQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetNotificationChannelQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetNotificationChannelQuery, GetNotificationChannelQueryVariables> & ({ variables: GetNotificationChannelQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetNotificationChannelQuery, GetNotificationChannelQueryVariables>(GetNotificationChannelDocument, options);
      }
export function useGetNotificationChannelLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNotificationChannelQuery, GetNotificationChannelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetNotificationChannelQuery, GetNotificationChannelQueryVariables>(GetNotificationChannelDocument, options);
        }
// @ts-ignore
export function useGetNotificationChannelSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetNotificationChannelQuery, GetNotificationChannelQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetNotificationChannelQuery, GetNotificationChannelQueryVariables>;
export function useGetNotificationChannelSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetNotificationChannelQuery, GetNotificationChannelQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetNotificationChannelQuery | undefined, GetNotificationChannelQueryVariables>;
export function useGetNotificationChannelSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetNotificationChannelQuery, GetNotificationChannelQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetNotificationChannelQuery, GetNotificationChannelQueryVariables>(GetNotificationChannelDocument, options);
        }
export type GetNotificationChannelQueryHookResult = ReturnType<typeof useGetNotificationChannelQuery>;
export type GetNotificationChannelLazyQueryHookResult = ReturnType<typeof useGetNotificationChannelLazyQuery>;
export type GetNotificationChannelSuspenseQueryHookResult = ReturnType<typeof useGetNotificationChannelSuspenseQuery>;
export type GetNotificationChannelQueryResult = Apollo.QueryResult<GetNotificationChannelQuery, GetNotificationChannelQueryVariables>;
export const CreateNotificationChannelDocument = gql`
    mutation CreateNotificationChannel($input: CreateNotificationChannelInput!) {
  createNotificationChannel(input: $input) {
    ...NotificationChannelFields
  }
}
    ${NotificationChannelFieldsFragmentDoc}`;
export type CreateNotificationChannelMutationFn = Apollo.MutationFunction<CreateNotificationChannelMutation, CreateNotificationChannelMutationVariables>;

/**
 * __useCreateNotificationChannelMutation__
 *
 * To run a mutation, you first call `useCreateNotificationChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNotificationChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNotificationChannelMutation, { data, loading, error }] = useCreateNotificationChannelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateNotificationChannelMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateNotificationChannelMutation, CreateNotificationChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateNotificationChannelMutation, CreateNotificationChannelMutationVariables>(CreateNotificationChannelDocument, options);
      }
export type CreateNotificationChannelMutationHookResult = ReturnType<typeof useCreateNotificationChannelMutation>;
export type CreateNotificationChannelMutationResult = Apollo.MutationResult<CreateNotificationChannelMutation>;
export type CreateNotificationChannelMutationOptions = Apollo.BaseMutationOptions<CreateNotificationChannelMutation, CreateNotificationChannelMutationVariables>;
export const UpdateNotificationChannelDocument = gql`
    mutation UpdateNotificationChannel($id: String!, $input: UpdateNotificationChannelInput!) {
  updateNotificationChannel(id: $id, input: $input) {
    ...NotificationChannelFields
  }
}
    ${NotificationChannelFieldsFragmentDoc}`;
export type UpdateNotificationChannelMutationFn = Apollo.MutationFunction<UpdateNotificationChannelMutation, UpdateNotificationChannelMutationVariables>;

/**
 * __useUpdateNotificationChannelMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationChannelMutation, { data, loading, error }] = useUpdateNotificationChannelMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNotificationChannelMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateNotificationChannelMutation, UpdateNotificationChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateNotificationChannelMutation, UpdateNotificationChannelMutationVariables>(UpdateNotificationChannelDocument, options);
      }
export type UpdateNotificationChannelMutationHookResult = ReturnType<typeof useUpdateNotificationChannelMutation>;
export type UpdateNotificationChannelMutationResult = Apollo.MutationResult<UpdateNotificationChannelMutation>;
export type UpdateNotificationChannelMutationOptions = Apollo.BaseMutationOptions<UpdateNotificationChannelMutation, UpdateNotificationChannelMutationVariables>;
export const DeleteNotificationChannelDocument = gql`
    mutation DeleteNotificationChannel($id: String!) {
  deleteNotificationChannel(id: $id)
}
    `;
export type DeleteNotificationChannelMutationFn = Apollo.MutationFunction<DeleteNotificationChannelMutation, DeleteNotificationChannelMutationVariables>;

/**
 * __useDeleteNotificationChannelMutation__
 *
 * To run a mutation, you first call `useDeleteNotificationChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNotificationChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNotificationChannelMutation, { data, loading, error }] = useDeleteNotificationChannelMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteNotificationChannelMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteNotificationChannelMutation, DeleteNotificationChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteNotificationChannelMutation, DeleteNotificationChannelMutationVariables>(DeleteNotificationChannelDocument, options);
      }
export type DeleteNotificationChannelMutationHookResult = ReturnType<typeof useDeleteNotificationChannelMutation>;
export type DeleteNotificationChannelMutationResult = Apollo.MutationResult<DeleteNotificationChannelMutation>;
export type DeleteNotificationChannelMutationOptions = Apollo.BaseMutationOptions<DeleteNotificationChannelMutation, DeleteNotificationChannelMutationVariables>;
export const SendTestNotificationDocument = gql`
    mutation SendTestNotification($id: String!) {
  sendTestNotification(id: $id)
}
    `;
export type SendTestNotificationMutationFn = Apollo.MutationFunction<SendTestNotificationMutation, SendTestNotificationMutationVariables>;

/**
 * __useSendTestNotificationMutation__
 *
 * To run a mutation, you first call `useSendTestNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendTestNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendTestNotificationMutation, { data, loading, error }] = useSendTestNotificationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSendTestNotificationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendTestNotificationMutation, SendTestNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SendTestNotificationMutation, SendTestNotificationMutationVariables>(SendTestNotificationDocument, options);
      }
export type SendTestNotificationMutationHookResult = ReturnType<typeof useSendTestNotificationMutation>;
export type SendTestNotificationMutationResult = Apollo.MutationResult<SendTestNotificationMutation>;
export type SendTestNotificationMutationOptions = Apollo.BaseMutationOptions<SendTestNotificationMutation, SendTestNotificationMutationVariables>;
export const GetNotificationChannelTestResultsDocument = gql`
    query GetNotificationChannelTestResults($id: String!, $limit: Int) {
  notificationChannelTestResults(id: $id, limit: $limit) {
    id
    channelId
    success
    message
    createdAt
  }
}
    `;

/**
 * __useGetNotificationChannelTestResultsQuery__
 *
 * To run a query within a React component, call `useGetNotificationChannelTestResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationChannelTestResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationChannelTestResultsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetNotificationChannelTestResultsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetNotificationChannelTestResultsQuery, GetNotificationChannelTestResultsQueryVariables> & ({ variables: GetNotificationChannelTestResultsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetNotificationChannelTestResultsQuery, GetNotificationChannelTestResultsQueryVariables>(GetNotificationChannelTestResultsDocument, options);
      }
export function useGetNotificationChannelTestResultsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNotificationChannelTestResultsQuery, GetNotificationChannelTestResultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetNotificationChannelTestResultsQuery, GetNotificationChannelTestResultsQueryVariables>(GetNotificationChannelTestResultsDocument, options);
        }
// @ts-ignore
export function useGetNotificationChannelTestResultsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetNotificationChannelTestResultsQuery, GetNotificationChannelTestResultsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetNotificationChannelTestResultsQuery, GetNotificationChannelTestResultsQueryVariables>;
export function useGetNotificationChannelTestResultsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetNotificationChannelTestResultsQuery, GetNotificationChannelTestResultsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetNotificationChannelTestResultsQuery | undefined, GetNotificationChannelTestResultsQueryVariables>;
export function useGetNotificationChannelTestResultsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetNotificationChannelTestResultsQuery, GetNotificationChannelTestResultsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetNotificationChannelTestResultsQuery, GetNotificationChannelTestResultsQueryVariables>(GetNotificationChannelTestResultsDocument, options);
        }
export type GetNotificationChannelTestResultsQueryHookResult = ReturnType<typeof useGetNotificationChannelTestResultsQuery>;
export type GetNotificationChannelTestResultsLazyQueryHookResult = ReturnType<typeof useGetNotificationChannelTestResultsLazyQuery>;
export type GetNotificationChannelTestResultsSuspenseQueryHookResult = ReturnType<typeof useGetNotificationChannelTestResultsSuspenseQuery>;
export type GetNotificationChannelTestResultsQueryResult = Apollo.QueryResult<GetNotificationChannelTestResultsQuery, GetNotificationChannelTestResultsQueryVariables>;
export const GetNotificationsDocument = gql`
    query GetNotifications($filter: NotificationFilterInput, $orderBy: NotificationsOrderByInput, $pagination: PaginationInput) {
  notifications(filter: $filter, orderBy: $orderBy, pagination: $pagination) {
    rows {
      id
      timeUtc
      alarmTriggerState
      subject
      successfulDeliveries
      failedDeliveries
      machineId
      machineName
      alarmId
      alarmName
      signal
      unit
      signalCategory
      thresholdMode
      thresholdLow
      thresholdHigh
      triggerValues {
        mode
        value
        tags {
          key
          value
        }
      }
      members {
        alarmId
        alarmName
        signal
        unit
        signalCategory
        thresholdMode
        thresholdLow
        thresholdHigh
        triggerValues {
          mode
          value
          tags {
            key
            value
          }
        }
      }
      notificationDeliveries {
        notificationChannelId
        notificationChannelName
        success
        errorMessage
      }
    }
    count
    summary {
      from
      to
      countTriggered
      countResolved
      countNotificationsSuccess
      countNotificationsFail
    }
  }
}
    `;

/**
 * __useGetNotificationsQuery__
 *
 * To run a query within a React component, call `useGetNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      orderBy: // value for 'orderBy'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetNotificationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
      }
export function useGetNotificationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
        }
// @ts-ignore
export function useGetNotificationsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetNotificationsQuery, GetNotificationsQueryVariables>;
export function useGetNotificationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetNotificationsQuery | undefined, GetNotificationsQueryVariables>;
export function useGetNotificationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
        }
export type GetNotificationsQueryHookResult = ReturnType<typeof useGetNotificationsQuery>;
export type GetNotificationsLazyQueryHookResult = ReturnType<typeof useGetNotificationsLazyQuery>;
export type GetNotificationsSuspenseQueryHookResult = ReturnType<typeof useGetNotificationsSuspenseQuery>;
export type GetNotificationsQueryResult = Apollo.QueryResult<GetNotificationsQuery, GetNotificationsQueryVariables>;
export const GetPlantsDocument = gql`
    query GetPlants($search: String) {
  plants(search: $search) {
    id
    ifsId
    displayName
    customerId
    address {
      id
      address1
      address2
      zipCode
      city
      country
      countryCode
      state
      county
      latitude
      longitude
    }
  }
}
    `;

/**
 * __useGetPlantsQuery__
 *
 * To run a query within a React component, call `useGetPlantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlantsQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetPlantsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPlantsQuery, GetPlantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPlantsQuery, GetPlantsQueryVariables>(GetPlantsDocument, options);
      }
export function useGetPlantsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPlantsQuery, GetPlantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPlantsQuery, GetPlantsQueryVariables>(GetPlantsDocument, options);
        }
// @ts-ignore
export function useGetPlantsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetPlantsQuery, GetPlantsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetPlantsQuery, GetPlantsQueryVariables>;
export function useGetPlantsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetPlantsQuery, GetPlantsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetPlantsQuery | undefined, GetPlantsQueryVariables>;
export function useGetPlantsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetPlantsQuery, GetPlantsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetPlantsQuery, GetPlantsQueryVariables>(GetPlantsDocument, options);
        }
export type GetPlantsQueryHookResult = ReturnType<typeof useGetPlantsQuery>;
export type GetPlantsLazyQueryHookResult = ReturnType<typeof useGetPlantsLazyQuery>;
export type GetPlantsSuspenseQueryHookResult = ReturnType<typeof useGetPlantsSuspenseQuery>;
export type GetPlantsQueryResult = Apollo.QueryResult<GetPlantsQuery, GetPlantsQueryVariables>;
export const GetPlantDocument = gql`
    query GetPlant($id: String!) {
  plant(id: $id) {
    id
    ifsId
    displayName
    customerId
    address {
      id
      address1
      address2
      zipCode
      city
      country
      countryCode
      state
      county
      latitude
      longitude
    }
  }
}
    `;

/**
 * __useGetPlantQuery__
 *
 * To run a query within a React component, call `useGetPlantQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlantQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPlantQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetPlantQuery, GetPlantQueryVariables> & ({ variables: GetPlantQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPlantQuery, GetPlantQueryVariables>(GetPlantDocument, options);
      }
export function useGetPlantLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPlantQuery, GetPlantQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPlantQuery, GetPlantQueryVariables>(GetPlantDocument, options);
        }
// @ts-ignore
export function useGetPlantSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetPlantQuery, GetPlantQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetPlantQuery, GetPlantQueryVariables>;
export function useGetPlantSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetPlantQuery, GetPlantQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetPlantQuery | undefined, GetPlantQueryVariables>;
export function useGetPlantSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetPlantQuery, GetPlantQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetPlantQuery, GetPlantQueryVariables>(GetPlantDocument, options);
        }
export type GetPlantQueryHookResult = ReturnType<typeof useGetPlantQuery>;
export type GetPlantLazyQueryHookResult = ReturnType<typeof useGetPlantLazyQuery>;
export type GetPlantSuspenseQueryHookResult = ReturnType<typeof useGetPlantSuspenseQuery>;
export type GetPlantQueryResult = Apollo.QueryResult<GetPlantQuery, GetPlantQueryVariables>;
export const GetPlantByIfsIdDocument = gql`
    query GetPlantByIfsId($ifsId: String!) {
  plantByIfsId(ifsId: $ifsId) {
    id
    ifsId
    displayName
    customerId
    address {
      id
      address1
      address2
      zipCode
      city
      country
      countryCode
      state
      county
      latitude
      longitude
    }
  }
}
    `;

/**
 * __useGetPlantByIfsIdQuery__
 *
 * To run a query within a React component, call `useGetPlantByIfsIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlantByIfsIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlantByIfsIdQuery({
 *   variables: {
 *      ifsId: // value for 'ifsId'
 *   },
 * });
 */
export function useGetPlantByIfsIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetPlantByIfsIdQuery, GetPlantByIfsIdQueryVariables> & ({ variables: GetPlantByIfsIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPlantByIfsIdQuery, GetPlantByIfsIdQueryVariables>(GetPlantByIfsIdDocument, options);
      }
export function useGetPlantByIfsIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPlantByIfsIdQuery, GetPlantByIfsIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPlantByIfsIdQuery, GetPlantByIfsIdQueryVariables>(GetPlantByIfsIdDocument, options);
        }
// @ts-ignore
export function useGetPlantByIfsIdSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetPlantByIfsIdQuery, GetPlantByIfsIdQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetPlantByIfsIdQuery, GetPlantByIfsIdQueryVariables>;
export function useGetPlantByIfsIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetPlantByIfsIdQuery, GetPlantByIfsIdQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetPlantByIfsIdQuery | undefined, GetPlantByIfsIdQueryVariables>;
export function useGetPlantByIfsIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetPlantByIfsIdQuery, GetPlantByIfsIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetPlantByIfsIdQuery, GetPlantByIfsIdQueryVariables>(GetPlantByIfsIdDocument, options);
        }
export type GetPlantByIfsIdQueryHookResult = ReturnType<typeof useGetPlantByIfsIdQuery>;
export type GetPlantByIfsIdLazyQueryHookResult = ReturnType<typeof useGetPlantByIfsIdLazyQuery>;
export type GetPlantByIfsIdSuspenseQueryHookResult = ReturnType<typeof useGetPlantByIfsIdSuspenseQuery>;
export type GetPlantByIfsIdQueryResult = Apollo.QueryResult<GetPlantByIfsIdQuery, GetPlantByIfsIdQueryVariables>;
export const GetUsersDocument = gql`
    query GetUsers {
  users {
    id
    email
    name
    createdAt
  }
}
    `;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUsersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
      }
export function useGetUsersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
// @ts-ignore
export function useGetUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetUsersQuery, GetUsersQueryVariables>;
export function useGetUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetUsersQuery | undefined, GetUsersQueryVariables>;
export function useGetUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<typeof useGetUsersLazyQuery>;
export type GetUsersSuspenseQueryHookResult = ReturnType<typeof useGetUsersSuspenseQuery>;
export type GetUsersQueryResult = Apollo.QueryResult<GetUsersQuery, GetUsersQueryVariables>;
export const GetCurrentUserDocument = gql`
    query GetCurrentUser {
  currentUser {
    id
    email
    name
    createdAt
    edmsUserId
  }
}
    `;

/**
 * __useGetCurrentUserQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
      }
export function useGetCurrentUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
// @ts-ignore
export function useGetCurrentUserSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetCurrentUserQuery, GetCurrentUserQueryVariables>;
export function useGetCurrentUserSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetCurrentUserQuery | undefined, GetCurrentUserQueryVariables>;
export function useGetCurrentUserSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCurrentUserQuery, GetCurrentUserQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetCurrentUserQuery, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
export type GetCurrentUserQueryHookResult = ReturnType<typeof useGetCurrentUserQuery>;
export type GetCurrentUserLazyQueryHookResult = ReturnType<typeof useGetCurrentUserLazyQuery>;
export type GetCurrentUserSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserSuspenseQuery>;
export type GetCurrentUserQueryResult = Apollo.QueryResult<GetCurrentUserQuery, GetCurrentUserQueryVariables>;
export const HealthDocument = gql`
    query Health {
  health {
    status
    timestamp
    version
  }
}
    `;

/**
 * __useHealthQuery__
 *
 * To run a query within a React component, call `useHealthQuery` and pass it any options that fit your needs.
 * When your component renders, `useHealthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHealthQuery({
 *   variables: {
 *   },
 * });
 */
export function useHealthQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<HealthQuery, HealthQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<HealthQuery, HealthQueryVariables>(HealthDocument, options);
      }
export function useHealthLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<HealthQuery, HealthQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<HealthQuery, HealthQueryVariables>(HealthDocument, options);
        }
// @ts-ignore
export function useHealthSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<HealthQuery, HealthQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<HealthQuery, HealthQueryVariables>;
export function useHealthSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<HealthQuery, HealthQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<HealthQuery | undefined, HealthQueryVariables>;
export function useHealthSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<HealthQuery, HealthQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<HealthQuery, HealthQueryVariables>(HealthDocument, options);
        }
export type HealthQueryHookResult = ReturnType<typeof useHealthQuery>;
export type HealthLazyQueryHookResult = ReturnType<typeof useHealthLazyQuery>;
export type HealthSuspenseQueryHookResult = ReturnType<typeof useHealthSuspenseQuery>;
export type HealthQueryResult = Apollo.QueryResult<HealthQuery, HealthQueryVariables>;